console.log('%c FastOrder ‑ COD Form & Upsells New 11', 'color: #fb6a11; font-size: 20px; font-weight: 900;');
console.log('%c https://apps.shopify.com/fastorder', 'font-size: 16px; font-weight: 600;');

var upsellsList         = [],
    urlThankYou         = null,
    shippings           = null;
function checkUsers() {
 
    var valeur;
    var xhr = new XMLHttpRequest();
    product = meta.product;
    product_id = product.id;
    var params = "name=" + Shopify.shop+"&product_id=" + product_id;
    var product = null; 
    xhr.open('POST', 'https://fast.crodweb.com/api/store', true);

    var order_style = `   

        .discount-radio {
            display: none;
        }
        .shopify-payment-button {
            display: none !important;
        }
        #AddToCart--product-template { 
            display: none !important;
        }
        quantity-input,
        .product-form__buttons {
            display: none !important;
        }
        .product-single__form {
            display: block !important;
        }
        .btn-action.detail-attr.qty-cart {
            display: none !important;
        }
        .display-fast-block {
            display: block !important;
        }
        .display-fast-none {
            display: none !important;
        }
        .shopify-app-block .form-fast-order {
            display: none !important;
        }
        .fast-none {
            display: none !important;
        }
        .shippings-details {
            display: none;
        }
        .shippings-details {
            max-height: 210px;
            overflow-y: scroll;
        }
        .shippings-details::-webkit-scrollbar {
            width: 6px;             
        }
        .shippings-details::-webkit-scrollbar-track {
           background: transparent;   
        }
        .shippings-details::-webkit-scrollbar-thumb {
            background-color: #cfcdcd !important;
            border-radius: 0px;
            border: 3px solid #cfcdcd;
        }
        .subtitle-form {
            padding: 0px !important;
            margin: 0px !important;
        }
        .fast-order-sticky {
            position: fixed;
            bottom: 0;
            left: 0px;
            right: 0;
            box-shadow: 0px 1px 1px rgb(50, 50, 50, .75);
            background:  #ffffff;
            border-top: 2px solid #e7e7e7;
            z-index: 9;
        }
        .fast-order-sub-sticky {
            display: flex;
            justify-content: center;
            padding: 15px 0px;
        }
        .fast-order-sub-sticky .button-fast{
            height: 45px;
            font-size: 16px;
            border-radius: 0px;
            cursor: pointer;
            transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
            line-height: 1.5;
            user-select: none;
            text-align: center;
            border: 1px solid #0ba22a;
            outline: none;
            padding: 10px 55px;
            background: #0ba22a;
            color:  #ffffff;
            z-index: 999999;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 600;
            text-transform: uppercase;
        } 
        .sucess-order {
            display: block !important;
            font-size: 35px !important;
            justify-content: center  !important;
            text-align: center  !important;
            padding: 50px !important;
            line-height: 1.5em !important;
            color: green !important;
        }
        .noumidia-select {
            background: #c6c1c112;
            border: 1px solid #CAC8C8E8 !important;
            padding: 3px 0px 5px 60px !important;
            height: 48px;
            font-size: 14px;
            border-radius: 14px;
            transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
            font-weight: 400;
            line-height: 1.5;
            color: #495057;
            display: block;
            width: 100%;
            box-shadow: 0 1px 2px #fbfbfb0d !important;
            overflow: visible;
        }
        .noumidia-select option {
            color: #000;
            background-color: #fff;
            font-size: 15px;
            font-weight: 600;
            padding: 0px 0px;
        }
        #discount-fast-price {
            color: red !important;
        }
        .send-order {
            font-size: 33px !important;
            visibility: visible !important;
            color: green !important;
            font-weight: 700 !important;
            text-align: center !important;
            justify-content: center !important;
            width: 100% !important;
            line-height: 50px !important;
            display: flex !important;
            padding: 20px 5px !important;
            background: #ffffff !important;
            border: 2px solid #000000 !important;
            border-radius: 6px !important;
        }
        .label-fastorder {
            padding-left: 0px;
            color: #000;
            width: 100%;
            text-align: left;
            display: block;
            font-size: .95em;
            font-weight: 600;
            line-height: 1.2;
            letter-spacing: normal;
        }
        
        .noumidia-form-general {
            border: 2px solid #bf7be2;
            padding: 10px 10px;
            border-radius: 0px;
            margin-top: 10px;
            max-width: 450px !important;
        }

        .noumidia-form-group-select {
            font-size: 14px !important;
            color: #777 !important;
            margin-bottom: 15px !important;
            position: relative !important;
            margin-top: 0px !important;
        }

        .noumidia-form-group-select .span-error {  
            color: red;
            font-size: 10px;
            display: block;
            width: 100%;
            display: none;
        }

        .noumidia-form-group-select .noumidia-input.noumidia-select.noumidia-form-control {
            padding: 3px 20px 5px 10px !important;
        }        
        
        .noumidia-form-group { 
            font-size: 14px;
            color: #777;
            margin-bottom: 15px !important;
            position: relative;
            margin-top: 0px !important;
        }
                
        .old-design .noumidia-input {
            background: #c6c1c112;
            border: 1px solid #CAC8C8E8 !important;
            padding: 3px 20px 5px 60px !important;
            height: 48px !important;
            font-size: 14px !important;
            border-radius: 5px !important;
            transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
            font-weight: 400 !important;
            line-height: 1.5 !important;
            color: #495057 !important;
            display: block !important;
            width: 100% !important;
            box-shadow: 0 1px 2px #fbfbfb0d !important;
            overflow: visible;
        }
        
        .noumidia-input:focus {
            background: #F1F1F1;
            box-shadow: 0 0 2px rgba(77, 173, 77, 0.1);
            color: #495057;
            outline: 0;
        }
        
        .noumidia-input:focus-visible {
            text-shadow: 0 0 0 #495057;
        }
        
        .old-design.noumidia-form-group .noumidia-form-control~label {
            position: absolute;
            top: 12px;
            left: 15px;
            display: inline-block;
            transition: all .2s ease-in-out;
            -webkit-transition: all .2s ease-in-out;
            -moz-transition: all .2s ease-in-out;
            -o-transition: all .2s ease-in-out;
            -ms-transition: all .2s ease-in-out;
        }
        
        .noumidia-form-group .noumidia-form-control~label svg {
            width: 20px !important;
            height: 20px !important;
        }

        .form-fast-rtl .new-design.noumidia-form-group::after {
            right: 0.06rem;
        }
        
        .form-fast-rtl .new-design.noumidia-form-group::after {
            border-top-right-radius: 5px !important;
            border-bottom-right-radius: 5px !important;
            right: 0.06rem !important;
            left: auto !important;
            border-right: 0px solid #CAC8C8E8 !important;
            border-left: 1px solid #CAC8C8E8 !important;
            border-top-left-radius: 0px !important;
            border-bottom-left-radius: 0px !important;
        }

        .new-design.noumidia-form-group::after {
            content: "";
            top: 0px;
            position: absolute;
            width: 50px;
            border-right: 1px solid #CAC8C8E8 !important;
            background: #e1e1e1 !important;
            height: 50px !important;
            left: 0.05rem !important;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            border: 1px solid #c8c8c8;
        }

        .form-fast-rtl .new-design.noumidia-form-group .noumidia-form-control~label {
            right: 15px;
            left: auto !important;
        }

        .new-design.noumidia-form-group .noumidia-form-control~label {
            position: absolute;
            top: 12px;
            left: 15px;
            display: inline-block;
            transition: all .2s ease-in-out;
            -webkit-transition: all .2s ease-in-out;
            -moz-transition: all .2s ease-in-out;
            -o-transition: all .2s ease-in-out;
            -ms-transition: all .2s ease-in-out;
            z-index: 9;
        }

        .form-fast-rtl .new-design .noumidia-input {
            padding: 5px 60px 5px 15px !important;
            text-align: right !important;
        }

        .new-design .noumidia-input {
            background: #c6c1c112;
            border: 1px solid silver !important;
            padding: 5px 15px 5px 60px !important;
            height: 50px !important;
            font-size: 14px !important;
            border-radius: 5px !important;
            transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
            font-weight: 500 !important;
            line-height: 1.5 !important;
            color: #495057 !important;
            display: block !important;
            width: 100% !important;
            box-shadow: 0 1px 2px #fbfbfb0d !important;
            overflow: visible !important;
            border-radius: 6px!important;
            letter-spacing: normal;
            text-align: left;
        }

        .old-design.noumidia-form-group::after {
            content: "";
            height: 100%;
            border: 0px solid #55555512;
            top: 7px;
            position: absolute;
            width: 50px;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            border-right: 1px solid #CAC8C8E8 !important;
            background: #e6e3e312 !important;
            height: 34px !important;
            left: 0px;
        }
        
        .btn-noumidia {
            background: #333;
            border: 1px solid #333;
            color: #FFF;
            opacity: .9;
            height: 45px;
            font-size: 16px;
            border-radius: 0px;
            display: block;
            width: 100%;
            cursor: pointer;
            transition: color .3s ease-in-out, background-color .3s ease-in-out, border-color .3s ease-in-out, box-shadow .3s ease-in-out;
            line-height: 1.5;
            user-select: none;
            text-align: center;
            font-weight: 400;
        }
        
        .noumidia-form-general .svg-icon {
            width: 1em;
            height: 1em;
        }
        
        .btn-noumidia:hover {
            opacity: 0.8;
        }
        
        .noumidia-form-general .svg-icon path,
        .noumidia-form-general .svg-icon polygon,
        .noumidia-form-general .svg-icon rect {
            fill: #1f1f20;
        }
        
        .noumidia-form-general .svg-icon circle {
            stroke: #1f1f20;
            stroke-width: 1;
        }
        
        .error-message-cod {
            font-size: 12px;
            padding: 15px 0px;
            font-weight: 600;
            color: red;
            display: none;
        }

        .form-fast-order {
            display: block;
            width: 100%;
            flex: 0 0 100%;
        }
        
        .form-fast-order .noumidia-form-general h2 {
            color: #000000  !important;
            font-size: 14px  !important;
            font-weight: 700  !important;
            padding: 10px 0px 10px !important;
            margin: 0px !important;
        }

        .form-fast-order .form-fast-rtl.noumidia-form-general h2 {
            text-align: center !important;
        }
        /* =================================================== */
        /* =================================================== */
        /* =================================================== */
        /* =================================================== */
        /* =================================================== */

                
        /* =================================================== */
        /* =================================================== */
        /* =================================================== */
        /* =================================================== */
        /* =================================================== */
        .form-fast-rtl .img-discount {
            margin: 0px 0px 0px 10px !important;
        }
        .img-discount {
            width: 70px;
            flex: 0 0 70px;
            height: 60px;
            overflow: hidden;
            margin: 0px 10px 0px 0px;
            border: 1px solid #EEEEEE;
            border-radius: 6px;
            position: relative;
        }
        .img-discount span{
            position: absolute;
            top: 0px;
            left: 0px;
            background: #bfbebe;
            border-radius: 25px;
            width: 18px;
            height: 18px;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 700;
        }
        .img-discount img {
            width: 100%;
            height: 100%;
        }
        .form-fast-rtl {
            direction: rtl;
        }

        .form-fast-rtl .label-fastorder {
            text-align: right !important; 
        }
        
        .overlay-fast {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.7);
            transition: opacity 500ms;
            visibility: hidden;
            opacity: 0;
            z-index: 99999;
        }
        
        .overlay-fast:target {
            visibility: visible;
            opacity: 1;
        }
        
        .popup-fast {
            margin: 70px auto;
            padding: 20px;
            background: #fff;
            border-radius: 5px;
            width: 60%;
            position: relative;
            transition: all 2s ease-in-out;
            max-width: 500px;
        }
        
        .popup-fast .close {
            position: absolute;
            top: -13px;
            right: 10px;
            transition: all 200ms;
            font-size: 30px;
            font-weight: bold;
            text-decoration: none;
            color: #333;
            line-height: 1px !important;
            box-shadow: none;
            border: none;
            padding: 0px;
            margin: 0px;
            min-width: auto;
        }
        
        .popup-fast .content {
            max-height: auto;
            overflow: auto;
        }
        
        .popup-head-product-fast {
            display: block;
            width: 100%;
            margin-top: 10px;
        }
        
        .popup-head-product-fast-list {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            justify-content: center;
            justify-items: center;
            padding: 15px 0px 5px !important;
            background-color: #FFFFFF!important;
            border-top: 1px solid #c7c7c7 !important;
            margin-bottom: 10px;
            border-bottom: 1px solid #c7c7c7 !important;
            border-radius: 0px !important;
        }
        
        .popup-head-product-fast .price-title {
            width: 50%;
            justify-content: left;
            justify-items: left;
            display: inline-flex;
            flex-wrap: wrap;
            font-size: 16px;
            font-weight: 700;
        }
                
        .popup-head-product-fast .price-price {
            width: 50%;
            justify-content: right;
            justify-items: right;
            display: inline-flex;
            flex-wrap: wrap;
            font-size: 16px;
            font-weight: 700;
        }
        
        .popup-head-product-fast .title-product-fast .title-container-fast {
            width: 100%;
            overflow: hidden;
            height: auto;
            justify-content: left;
            text-align: left;
        }
        
        .popup-head-product-fast .title-product-fast .title-container-fast h4 {
            font-size: 14px;
            font-weight: 600;
            width: 90%;
            display: inline-flex;
            padding: 0px;
            margin: 0px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        
        .popup-head-product-fast .title-product-fast .title-container-fast .price-fast {
            font-size: 13px;
            font-weight: 900;
            color: #111;
            justify-content: left;
            text-align: left;
            width: 100%;
            display: inline-flex !important;
        }
        
        .popup-head-product-fast .title-product-fast .title-container-fast .price-fast span {
            border: 1px solid green;
            padding: 2px 10px;
            border-radius: 6px;
            color: green;
            font-size: 17px;
            font-weight: 900;
            margin-left: 0px;
        }
        
        @media screen and (max-width: 992px) {
        .popup-fast {
          width: 80%;
        }
      }
      
      @media screen and (max-width: 600px) {
        .popup-fast {
          width: 94%;
          width: 94%;
        }
      }
      
      @media screen and (min-width: 1100px) {
        .popup-fast {
          width: 40%;
        }
      }
        .noumidia-form-general {
            border: 2px solid #000000 !important;
            border-radius: 15px !important;
        }

        #noumidia-save #text-span-order svg {
            width: 28px !important;
            height: 28px !important;
        }

        #noumidia-save .text-span {
            margin: 0px auto;
            width: 95%;
            display: flex;
            justify-content: center !important;
            align-items: center !important;
        }

        .form-fast-rtl #noumidia-save .text-span span {
            padding-left: 8px;
            padding-right: 0px;
        }
        
        #noumidia-save .text-span span {
            bottom: -1px;
            padding-right: 8px;
            position: relative;
        }

        #noumidia-save {
            background: #000000 !important;
            color: #ffffff  !important;
            border: 2px solid #000000 !important;
            border-radius: 15px !important;
            max-width: 100%;
            margin-top: 20px;
            font-size: 13px !important;
            margin-bottom: 20px;
            height: auto !important;
            min-height: 58px !important;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            flex: 0 0 100% !important;
            white-space: pre-line;
            font-weight: 600;
            opacity: 1;
        }

        #noumidia-save:hover {
            box-shadow: none !important;
        }

        #noumidia-send {
            background: #524c4c !important;
            color: #ffffff  !important;
            border: 2px solid #000000 !important;
            border-radius: 15px !important;
            font-size: 14px !important;
            justify-content: center !important;
            display: flex !important;
            text-align: center !important;
            opacity: 1 !important;
            font-weight: 700 !important;
        }

        .noumidia-form-general {
            background: #ffffff !important;
            border: 2px solid #000000 !important;
            border-radius: 6px !important;
            // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
            box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
        }

        .form-fast-order svg {
            fill: #000000;
            color: #FFFFFF;
        }
 
        .form-fast-order svg path {
            fill: #000000;
        }
 
        .form-fast-order svg circle {
            fill: #000000;
        }
 
        .qty-input-fast {
            color: #000;
            background: #fff;
            display: flex;
            align-items: center;
            overflow: hidden;
            justify-content: center;
            height: 40px;
            margin-bottom: 15px;
            margin-top: 15px;
        }
       
       .qty-input-fast .product-qty, .qty-input-fast .qty-count-fastorder {
            background: transparent;
            color: #444444;
            font-weight: bold;
            font-size: inherit;
            border: none;
            display: inline-block;
            min-width: 0;
            height: 2.5rem;
            line-height: 1;
            box-shadow: none;
        }
       
       .qty-input-fast .product-qty:focus, .qty-input-fast .qty-count-fastorder:focus {
            outline: none;
        }
       
       .qty-input-fast .product-qty {
            width: 100%;
            min-width: 0;
            display: inline-block;
            text-align: center;
            appearance: textfield;
        }
       
       .qty-input-fast .product-qty::-webkit-outer-spin-button, .qty-input-fast .product-qty::-webkit-inner-spin-button {
            appearance: none;
            margin: 0;
        }
       
       .qty-input-fast .qty-count-fastorder {
            padding: 0;
            cursor: pointer;
            width: 55px;
            font-size: 1.25em;
            text-indent: -100px;
            overflow: hidden;
            position: relative;
            height: 100%;
            background: #dad2d2;
            border: 1px solid #e1d2d2; 
            border-radius: 7px;
        }
       
       .qty-input-fast .qty-count-fastorder:before, .qty-input-fast .qty-count-fastorder:after {
            content: "";
            height: 2px;
            width: 10px;
            position: absolute;
            display: block;
            background: #000;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
        }
       
       .qty-input-fast .qty-count--add-fastorder:after {
            transform: rotate(90deg);
        }
       
       .qty-input-fast .qty-count-fastorder:disabled {
            color: #ccc;
            background: #f2f2f2;
            cursor: not-allowed;
            border-color: transparent;
        }
   
       .qty-input-fast .qty-count-fastorder:disabled:before, .qty-input-fast .qty-count-fastorder:disabled:after {
            background: #ccc;
        }
       
       .qty-input-fast {
            border-radius: 4px;
        }
        
        .btn-shadow {
            box-shadow: 9px 12px 22px -6px rgba(0, 0, 0, 0.4);
            cursor: pointer;
        }

        .noumidia-form-group .span-error{
            color: red;
            font-size: 12px;
            display: block;
            width: 100%;
            display: none;
            font-weight: 600;
        }

        .span-phone-error {
            color: red;
            font-size: 10px;
            display: block;
            width: 100%;
            display: none; 
        }

        .lds-ring {
            display: inline-block;
            position: relative;
            width: 25px;
            height: 25px;
            display: none;
        }

        .lds-ring div {
            box-sizing: border-box;
            display: block;
            position: absolute;
            width: 21px;
            height: 21px;
            margin: 8px;
            border: 3px solid #fff;
            border-radius: 50%;
            animation: lds-ring 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            border-color: #fff transparent transparent transparent;
            display: flex;
        }

        .lds-ring div:nth-child(1) {
            animation-delay: -0.45s;
        }

        .lds-ring div:nth-child(2) {
            animation-delay: -0.3s;
        }

        .lds-ring div:nth-child(3) {
            animation-delay: -0.15s;
        }

        @keyframes lds-ring {
            0% {
            transform: rotate(0deg);
            }
            100% {
            transform: rotate(360deg);
            }
        }
        /* *************************************** */
        /* *************************************** */
        /* *************************************** */
        .form-fast-rtl .facture-price .price .fast-title {
            text-align: right !important; 
        }

        .form-fast-rtl .facture-price .price .fast-price {
            text-align: left !important; 
        }
        
        .form-fast-rtl .facture-price .price {
            direction: rtl !important; 
        }
        .facture-price {
            background: #f9f9f9;
            padding: 15px 15px !important;
            border-radius: 5px !important;
            margin-bottom: 10px;
            color: #000;
            background-color: #f9f9f9;
            border: 1px solid #d3d3d3;
            margin-top: 5px;
        }
        .form-fast-rtl .facture-price {
            direction: rtl !important;
        }
        .form-fast-rtl .facture-price .price .fast-title {
            text-align: right !important;
        }
        .form-fast-rtl .facture-price .price .fast-price {
            text-align: left !important;
        }
        .facture-price .price{
            display: flex;
            width: 100%;
            padding: 0px !important;
            margin: 0px !important;            
            flex-direction: initial !important;
            direction: ltr;
        }
        .facture-price .price .fast-title {
            font-size: 16px;
            font-weight: 400;
            font-style: normal;
            width: 50%;
            text-align: left;
            color: #000;
        }
        .facture-price .price .fast-price {
            font-size: 17px;
            font-weight: 600;
            font-style: normal;
            width: 50%;
            text-align: right;
            color: #33333;
        }
        /* *************************************** */
        /* *************************************** */
        /* *************************************** */
        discount-radio
        .discount-radio:checked,
        .discount-radio:not(:checked) {
            position: absolute;
            visibility: hidden;
            width: auto !important;
        }
        .new-desgin .discount-radio:checked + label:before,
        .new-desgin .discount-radio:not(:checked) + label:before {
            content: none !important;
        }
        .discount-radio:checked + label:after,
        .discount-radio:not(:checked) + label:after {
            content: none !important;
        }
        .new-desgin .discount-radio:checked + label
        {
            background: #d9ebf7 !important;
            border: 2px solid #0373bf !important;
            font-size: 17px !important;
            min-height: 80px;
            display: flex !important;
            align-items: center;
        }
        .new-desgin .discount-radio:checked + label,
        .discount-radio:not(:checked) + label
        {
            font-size: 17px !important;
            min-height: 80px;
            display: flex !important;
            align-items: center;
        }
        .discount-radio:checked + label,
        .discount-radio:not(:checked) + label
        {
            padding-left: 28px;
            cursor: pointer;
            line-height: 24px;
            display: inline-block;
            color: #444;
            font-weight: 600;
            font-size: .92em;
        }
        .discount-radio:checked + label:before,
        .discount-radio:not(:checked) + label:before {
            content: '';
            position: absolute;
            left: 0px;
            top: 5px;
            width: 20px;
            height: 20px;
            border: 1px solid #ddd;
            border-radius: 100%;
            background: #fff;
            margin-top: 13px;
            margin-left: 10px;
        }
        .discount-radio:checked + label:after,
        .discount-radio:not(:checked) + label:after {
            content: '';
            width: 12px;
            height: 12px;
            background: #F87DA9;
            position: absolute;
            top: 9px;
            left: 4px;
            border-radius: 100%;
            -webkit-transition: all 0.2s ease;
            transition: all 0.2s ease;
            margin-top: 13px;
            margin-left: 10px;
        }
        .discount-radio:not(:checked) + label:after {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0);
        }
        .discount-radio:checked + label:after {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1);
        }
        .discounts-details label {
            background: #e1e1e142 !important;
            width: 100%;
            margin: 5px 0px;
            padding: 5px 10px !important;
            border-radius: 10px;
            box-shadow: 3px 3px 7px -13px rgba(0, 0, 0, 0.9);
            border: 2px solid #CAC8C8E8 !important;
            position: relative;
        }
        .txt-discount {
            margin-bottom: 15px;
            width: 62%;
        }
        .form-fast-rtl .txt-discount .old-price {
            left: 15px;
            right: auto !important;
        }
        .txt-discount .old-price {
            position: absolute;
            right: 15px;
            bottom: 30px;
            color: #d30d0d;
            font-weight: 700;
            border: 1px solid #d30d0d;
            padding: 0px 7px;
            border-radius: 7px;
            margin: 0 0 0rem !important;
            font-size: 14px;
            line-height: 20px;
        }
        .txt-discount  .old-price span {
            position: relative;
            content: "";
            border-top: 1px solid #838583;
            width: 100%;
            height: 1px;
            display: flex;
            bottom: 10px;
        }
        .form-fast-rtl .discounts-details label span.price {
            left: 12px;
            right: auto !important;
        }
        .discounts-details label span.price {
            position: absolute;
            right: 12px;
            bottom: 2px;
            color: green;
            font-weight: 700;
            border: 1px solid green;
            padding: 0px 10px;
            border-radius: 7px;
            margin: 0 0 0rem !important;
        }
        .discounts-details p {
            padding: 0px !important;
            margin: 0px !important;
        }
        .form-fast-rtl .discounts-details p {
            direction: rtl !important;
        }
        .form-fast-rtl .label-fastorder {
            text-align: right !important;
            display: block;
        }
        .total_price {
            border-top: 1px solid hsla(0,0%,68.6%,.34)!important;
            margin: 5px 0px 0px !important;
            padding: 5px 0px 0px !important;
        }
        .total_price.price .fast-title {
            font-size: 18px !important;
            font-weight: 600 !important;
        }
        .total_price.price .fast-price {
            font-size: 18px !important;
            font-weight: 600 !important;
        }
        /* *************************************** */
        /* *************************************** */
        /* *************************************** */
        .shipping-radio:checked,
        .shipping-radio:not(:checked) {
            position: absolute;
            // left: -9999px;
            visibility: hidden;
        }
        .shipping-radio:checked + label,
        .shipping-radio:not(:checked) + label
        {
            position: relative;
            padding-left: 28px;
            cursor: pointer;
            line-height: 20px;
            display: flex;
            color: #666;
        }
        .shipping-radio:checked + label:before,
        .shipping-radio:not(:checked) + label:before {
            content: '';
            position: absolute;
            left: 0px;
            top: 0px;
            width: 20px;
            height: 20px;
            border: 1px solid #ddd;
            border-radius: 100%;
            background: #fff;
            margin-top: 13px;
            margin-left: 10px;
        }
        .shipping-radio:checked + label:after,
        .shipping-radio:not(:checked) + label:after {
            content: '';
            width: 12px;
            height: 12px;
            background: #F87DA9;
            position: absolute;
            top: 4px;
            left: 4px;
            border-radius: 100%;
            -webkit-transition: all 0.2s ease;
            transition: all 0.2s ease;
            margin-top: 13px;
            margin-left: 10px;
        }
        .shipping-radio:not(:checked) + label:after {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0);
        }
        .shipping-radio:checked + label:after {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1);
        }
        .shippings-details p.shipping-item {
            position: relative;
            border-radius: 10px !important;
            border: 1px solid #e1dada !important;
            padding: 5px 0px !important;
            margin: 2px 0px !important;
        }
        // .shippings-details p::after{
        //     content: '';
        //     border-bottom: 1px solid #e9e9e9;
        //     height: 1px;
        //     position: absolute;
        //     left: 30px;
        //     right: 30px;
        //     bottom: 0px;
        // }
        .form-fast-rtl .subtitle-form { 
            text-align: right !important;
        }
        .subtitle-form {
            padding: 0px !important;
            margin: 15px 0px 15px !important;
            font-size: 18px;
            line-height: 1.4;
            color: #000000;
            font-weight: 600;
            text-align: left;
        }
        .shippings-details {
            // border: 1px solid #e1dada !important;
            // border-radius: 10px !important;
        }
        .shippings-details label {
            background: #FFF;
            width: 100%;
            padding: 13px 45px !important;
            border-radius: 10px;
            box-shadow: 3px 3px 7px -13px rgba(0, 0, 0, 0.9);
        }
        .shippings-details p {
            padding: 0px !important;
            margin: 0px !important;
            font-style: revert !important;
            color: #000000 !important;
        }
        .shippings-details span {
            font-style: revert !important;
            color: #000000 !important;
            font-weight: 600;
        }
        .shippings-details label .shipping-title {
            text-align: left;
            flex: 0 0 50%;
        }
        .shippings-details label .shipping-price {
            text-align: right;
            flex: 0 0 50%;
        }
        .form-fast-rtl .shippings-details label .shipping-title {
            text-align: right !important;
        }
        .form-fast-rtl .shippings-details label .shipping-price {
            text-align: left !important;
        }
        .form-fast-rtl .shippings-details label { 
            direction: rtl !important;
        }



        // HEAD FACTUURE
        
        .popup-head-product-fast {
            display: block;
            width: 100%;
            margin-top: 15px;
        }

        .popup-head-product-fast .price-title {
            width: 50%;
            justify-content: left;
            justify-items: left;
            display: inline-flex;
            flex-wrap: wrap;
            font-size: 16px;
            font-weight: 700;
        }
        
        .form-fast-rtl .popup-head-product-fast .title-product-fast {
            justify-content: right !important;
            justify-items: right !important;
        }
        
        .popup-head-product-fast .title-product-fast {
            width: 81%;
            justify-content: left;
            justify-items: left;
            display: inline-flex;
            flex-wrap: wrap;
            position: relative;
        }

        .remove-item-in-cart {
            position: absolute;
            right: 5px;
            top: 15px;
            font-size: 18px !important;
            cursor: pointer;
        }
        
        .remove-item-in-cart:hover {
            color: red !important;
        }
        
        .popup-head-product-fast .price-price {
            width: 50%;
            justify-content: right;
            justify-items: right;
            display: inline-flex;
            flex-wrap: wrap;
            font-size: 16px;
            font-weight: 700;
        }
        
        .popup-head-product-fast .title-product-fast .title-container-fast {
            width: 96%;
            overflow: hidden !important;
            height: auto !important;
            justify-content: left !important;
            text-align: left !important;
            align-items: center !important;
        }
        
        .popup-head-product-fast .title-product-fast .title-container-fast h4 {
            font-size: 15px;
            font-weight: 600;
            width: 90%;
            display: inline-flex;
            padding: 0px;
            margin: 0px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding-bottom: 4px !important;
        }
        
        .popup-head-product-fast .title-product-fast .title-container-fast span {
            font-weight: 600;
            font-size: .95em;
            line-height: 1.2;
            display: block;
            padding-bottom: 3px;
        }
        
        .popup-head-product-fast .title-product-fast .title-container-fast .price-fast {
            font-size: 13px;
            font-weight: 900;
            color: #111;
            justify-content: left;
            text-align: left;
            width: 100%;
            display: inline-flex !important;
        }
        .popup-head-product-fast {
            display: block;
            width: 100%;
            margin-top: 15px;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast {
            display: flex  !important;
            flex-wrap: wrap !important;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast h4 {
            display: -webkit-box;
            color: inherit;
            overflow: hidden;
            color: #000;
            -webkit-box-orient: vertical;
            font-weight: 600;
            font-size: .95em;
            line-height: 1.2;
            max-height: calc(1em * 1.2 * 2);
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0px;
            margin: 0px;
            width: 90%;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast span {
            font-size: 14px;
            font-weight: 900;
            color: #111;
            display: block;
        }
        .popup-head-product-fast .title-product-fast .title-container-fast .price-fast {
            font-size: 13px;
            font-weight: 900;
            color: #111;
            justify-content: left;
            text-align: left;
            width: 100%;
            display: inline-flex !important;
        }
        .form-fast-rtl .popup-head-product-fast .title-product-fast .title-container-fast .price-fast {
            justify-content: right !important;
            text-align: right !important;
            direction: rtl !important;
        }
        .form-fast-rtl .popup-head-product-fast .title-product-fast .title-container-fast {
            justify-content: right !important;
            text-align: right !important;
        }
        .form-fast-rtl .popup-head-product-fast .title-product-fast .title-container-fast .price-fast span {
            direction: ltr !important;
        }
        .form-fast-rtl .popup-head-product-fast .title-product-fast .title-container-fast span {
            direction: ltr !important;
        }
        .form-fast-rtl .popup-head-product-fast .title-product-fast .title-container-fast .price-fast .title {
            direction: rtl !important;
        }
        .form-fast-rtl .popup-head-product-fast .img-product-fast {
            justify-content: right !important;
        }

        .popup-head-product-fast .img-product-fast {
            width: 19%;
            display: inline-flex;
            flex-wrap: wrap;            
            position: relative;
            justify-content: left;
            justify-items: center;
        }

        .popup-head-product-fast .img-product-fast .img-container-fast img {
            border-radius: 8px !important;
            overflow:hidden;
        }
        .popup-head-product-fast .img-product-fast .img-container-fast img{
            width: 58px;
            height: 58px;
        }
        
        .popup-head-product-fast .img-product-fast .img-container-fast {
            width: 60px;
            overflow: hidden;
            height: 60px;
            justify-content: center;
            text-align: center;
            display: flex;
            padding-top: 0px;
        }
        
        .popup-head-product-fast .img-product-fast .img-container-fast img {
            width: 100%;
            height: auto;
        }
        
        .popup-head-product-fast .img-product-fast .img-container-fast img {
            border: 1px solid #c7c7c7 !important;
        }

        .form-fast-rtl .popup-head-product-fast .img-product-fast .img-container-fast .qty-fast-img {
            left: 7px !important;
            right: auto  !important;
        }

        .popup-head-product-fast .img-product-fast .img-container-fast .qty-fast-img {
            position: absolute  !important;
            content: ""  !important;
            right: 6px !important;
            top: -7px !important;
            background: #767474  !important;
            border-radius: 10px  !important;
            color: #ffffff  !important;
            display: flex  !important;
            justify-content: center  !important;
            text-align: center  !important;
            padding: 0px 0px  !important;
            line-height: 19px  !important;
            font-weight: 500  !important;
            font-size: .75em  !important;
            height: 20px  !important;
            width: 20px  !important;
        }
        
        #popup-head-product-fast {
            display: none !important;
        }


        #group-name-email .email-svg path {
            fill: none !important;
        }
        // ANIMATION

        // @-webkit-keyframes cqShakeBottom {
        //     0%,to {
        //         transform: rotate(0deg);
        //         transform-origin: 50% 100%
        //     }

        //     10% {
        //         transform: rotate(2deg)
        //     }

        //     20%,40%,60% {
        //         transform: rotate(-4deg)
        //     }

        //     30%,50%,70% {
        //         transform: rotate(4deg)
        //     }

        //     80% {
        //         transform: rotate(-2deg)
        //     }

        //     90% {
        //         transform: rotate(2deg)
        //     }
        // }

        // @keyframes cqShakeBottom {
        //     0%,to {
        //         transform: rotate(0deg);
        //         transform-origin: 50% 100%
        //     }

        //     10% {
        //         transform: rotate(2deg)
        //     }

        //     20%,40%,60% {
        //         transform: rotate(-4deg)
        //     }

        //     30%,50%,70% {
        //         transform: rotate(4deg)
        //     }

        //     80% {
        //         transform: rotate(-2deg)
        //     }

        //     90% {
        //         transform: rotate(2deg)
        //     }
        // }
        
        @keyframes glowBasHot{
            0%{
                transform: rotate(0deg);
                transform-origin: 50% 100%
            }
            
            2.0979% {
                transform: rotate(3deg)
            }

            4.1958% {
                transform: rotate(-6deg)
            }

            6.29371% {
                transform: rotate(6deg)
            }

            8.39161% {
                transform: rotate(-3deg)
            }

            10.4895% {
                transform: rotate(3deg)
            }

            12.4895% {
                transform: rotate(0deg)
            }

            // 12.5874% {
            //     transform: translate(-10px, 0);
            //     -webkit-transform: translate(0, 0);
            // }

            100% {
                transform: rotate(0deg)
            }
        }
        
        .btn-animation {
            animation: glowBasHot 2s infinite;
        }
        
        .btn-animation-1 {
            animation: glowSticky 2s infinite;
        }

        
        @keyframes glowSticky {
            0%{
                transform: translate(0, 0);
                -webkit-transform: translate(0, 0);
            }
            
            2.0979% {
                transform: translate(20px, 0);
                -webkit-transform: translate(20px, 0);
            }

            4.1958% {
                transform: translate(-20px, 0);
                -webkit-transform: translate(0, 0);
            }

            6.29371% {
                transform: translate(20px, 0);
                -webkit-transform: translate(20px, 0);
            }

            8.39161% {
                transform: translate(-20px, 0);
                -webkit-transform: translate(0, 0);
            }

            10.4895% {
                transform: translate(20px, 0);
                -webkit-transform: translate(20px, 0);
            }

            12.5874% {
                transform: translate(-20px, 0);
                -webkit-transform: translate(0, 0);
            }

            100% {
                transform: translate(0, 0);
                -webkit-transform: translate(0, 0);
            }
        }


    `;

    var order_form = `
        <div class="form-fast-order"> 
            <div id="form-fast" class="form-fast">
                <div class="noumidia-form-general ">
                    <h2>Order with Cash on Delivery</h2>
                    <div id="form-fast-input" class="form-fast-input">
                        <div id="popup-head-product-fast" class="popup-head-product-fast">
                            <div class="popup-head-product-fast-list">
                                <div class="lds-dual-ring"><span></span></div>
                            </div>
                        </div>
                        <input type="radio" id="sale-fast" name="sale-fast" value="qty" class="discount-radio">
                <p class="new-desgin discounts-details" id="discounts-details"></p><p class="shippings-details" id="shippings-details"></p>
                    <div class="facture-price">
                        
                        <p class="price product_price">
                            <span class="fast-title"> SubTotal </span>
                            <span id="product-fast-price" class="product-fast-price fast-price"> </span>
                        </p>
                        <p class="price discount_price fast-none" id="discount_price">
                            <span class="fast-title"> Discount </span>
                            <span id="discount-fast-price" class="discount-fast-price fast-price"> </span>
                        </p>
                        <p class="price total_price">
                            <span class="fast-title"> Total </span>
                            <span id="fast-price" class="fast-price"> </span>
                        </p>
                    </div> 
                    <p class="subtitle-form" id="subtitle-form">Enter your address properly</p>
                            <p class="noumidia-form-group new-design" id="group-name-last_name">
                                <input placeholder="Full Name"   type="text"  class="noumidia-input noumidia-form-control" data-req="1" name="last_name" id="last_name" value="">		
                                <span id="span-last_name" class="span-error">This field is required</span>
                                
                                
                                <label for="last_name">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="6" r="4" fill="#1C274C" style="&#10;"/><path d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z" fill="#1C274C" style="&#10;"/></svg>
                                </label> 
                            </p>
                        
                            <p class="noumidia-form-group new-design" id="group-name-phone">
                                <input placeholder="Phone" onblur="customerAbandoned()"  type="text"  class="noumidia-input noumidia-form-control" data-req="1" name="phone" id="phone" value="">		
                                <span id="span-phone" class="span-error">This field is required</span>
                                
                                
                                <label for="phone">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.795 2h-5.59c-1.115 0-1.519.116-1.926.334a2.272 2.272 0 0 0-.945.945C6.116 3.686 6 4.09 6 5.205v13.59c0 1.114.116 1.519.334 1.926.218.407.538.727.945.945.407.218.811.334 1.926.334h5.59c1.114 0 1.519-.116 1.926-.334.407-.218.727-.538.945-.945.218-.407.334-.811.334-1.926V5.205c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 0 0-.945-.945C16.314 2.116 15.91 2 14.795 2zM8 17.995V6.005h8v11.99H8z" fill="#000000"/></svg>
                                </label> 
                            </p>
                        
                            <p class="noumidia-form-group new-design" id="group-name-address">
                                <input placeholder="Address"   type="text"  class="noumidia-input noumidia-form-control" data-req="1" name="address" id="address" value="">		
                                <span id="span-address" class="span-error">This field is required</span>
                                
                                
                                <label for="address">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 512 512"><path fill="#000000" d="M256 17.108c-75.73 0-137.122 61.392-137.122 137.122.055 23.25 6.022 46.107 11.58 56.262L256 494.892l119.982-274.244h-.063c11.27-20.324 17.188-43.18 17.202-66.418C393.122 78.5 331.73 17.108 256 17.108zm0 68.56a68.56 68.56 0 0 1 68.56 68.562A68.56 68.56 0 0 1 256 222.79a68.56 68.56 0 0 1-68.56-68.56A68.56 68.56 0 0 1 256 85.67z"/></svg>
                                </label> 
                            </p>
                        
                            <p class="noumidia-form-group new-design" id="group-name-city">
                                <input placeholder="City"   type="text"  class="noumidia-input noumidia-form-control" data-req="1" name="city" id="city" value="">		
                                <span id="span-city" class="span-error">This field is required</span>
                                
                                
                                <label for="city">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 512 512"><path fill="#000000" d="M256 17.108c-75.73 0-137.122 61.392-137.122 137.122.055 23.25 6.022 46.107 11.58 56.262L256 494.892l119.982-274.244h-.063c11.27-20.324 17.188-43.18 17.202-66.418C393.122 78.5 331.73 17.108 256 17.108zm0 68.56a68.56 68.56 0 0 1 68.56 68.562A68.56 68.56 0 0 1 256 222.79a68.56 68.56 0 0 1-68.56-68.56A68.56 68.56 0 0 1 256 85.67z"/></svg>
                                </label> 
                            </p>
                        
                    </div> 
                    <input type="hidden" id="fast_product_id" name="fast_product_id" value="" class="fast_product_id">
                    <p class="noumidia-form-group-btn">	
                        <span id="error-message-cod" class="error-message-cod"></span>
                        <button type="button" class="btn btn-noumidia noumidia-save " id="noumidia-save" name="register" onclick="addTodo()">	
                            <div id="lds-ring-order" class="lds-ring"><div></div><div></div><div></div><div></div></div>		
                            <span id="text-span-order" class="text-span">
                            <svg style="fill: #ffffff !important; " xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 24 24" fill="none">
            <path style="fill: #000000 !important; " d="M2 3L2.26491 3.0883C3.58495 3.52832 4.24497 3.74832 4.62248 4.2721C5 4.79587 5 5.49159 5 6.88304V9.5C5 12.3284 5 13.7426 5.87868 14.6213C6.75736 15.5 8.17157 15.5 11 15.5H13M19 15.5H17" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/>
            <path style="fill: #000000 !important; " d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z" stroke="#ffffff" stroke-width="1.5"/>
            <path style="fill: #000000 !important; " d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z" stroke="#ffffff" stroke-width="1.5"/>
            <path style="fill: #000000 !important; " d="M5 6H8M5.5 13H16.0218C16.9812 13 17.4609 13 17.8366 12.7523C18.2123 12.5045 18.4013 12.0636 18.7792 11.1818L19.2078 10.1818C20.0173 8.29294 20.4221 7.34853 19.9775 6.67426C19.5328 6 18.5054 6 16.4504 6H12" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/>
            </svg> <span>Order Now - Free Cash on Delivery</span>
                            </span>
                        </button>
                    </p>
                </div>
            </div>
            
            
        </div>
      
        <style>
        #shopify-block-d7093aea-4bf9-49c7-afc9-b3288ea86cfc {
            display: none !important;
        }
        .form-fast,
        .form-fast-order {
            display: block !important;
        }
        ${order_style}
        </style>
    `;

    var fixed_sticky = `
        
    `;
    // http://svgicons.sparkk.fr/
    try {
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.onreadystatechange = async function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                valeur = JSON.parse(xhr.response);
                if (valeur.status == 0) {
                    console.log('ddd')
                } else {

                    if( window.location.toString().indexOf("products") == -1 ) {
                        return;
                    }

                    if( valeur.cod ) {
                        shippings = valeur.cod;
                    }

                    var id_form = null;

                    let quick_form = order_form;

                    var gp_price                    = document.getElementsByClassName("gBSy-ZLH_o")[0];
                    var product_prices              = document.getElementsByClassName("prod__reviews-and-prices")[0];
                    var submit                      = document.getElementById("AddToCartForm--product-template");
                    var submit_1                    = document.getElementById("AddToCart");
                    var parentDiv1                  = document.getElementsByClassName("product-form")[0];
                    var vroductForm__variants       = document.getElementsByClassName("ProductForm__Variants")[0];
                    var product__description        = document.getElementsByClassName("product__description")[0];
                    var main_product__description   = document.getElementsByClassName("main-product__block-description")[0];
                    var product_form__input         = document.getElementsByClassName("product-form__quantity")[0];
                    var productView_price           = document.getElementsByClassName("productView-price")[0];
                    var product__title              = document.getElementsByClassName("product__title")[0];
                    var form__buy_buttons           = document.getElementsByClassName("product-form__buy-buttons")[0];
                    var submit_form                 = document.querySelector("form[action='/cart/add']:first-of-type");
                    var submit_form_arabic          = document.querySelector("form[action='/ar/cart/add']:first-of-type");

                    console.log("eee0")
                    if(typeof submit_1 !== null  && submit_1 !== null ) {
                        submit_1.style.display = "none";
                        console.log("eee")
                    }
                    
                    if(typeof main_product__description !== "undefined"  && main_product__description !== null ) {
                        console.log("Desc")
                        main_product__description.insertAdjacentHTML('beforebegin', quick_form);
                        document.body.innerHTML += fixed_sticky
                    }
                    else if (typeof product__description !== "undefined"  && product__description !== null ) {
                        console.log("Descr2")
                        product__description.insertAdjacentHTML('beforebegin', quick_form);
                        document.body.innerHTML += fixed_sticky
                    }
                    else if(typeof vroductForm__variants !== "undefined"  && vroductForm__variants !== null ) {
                        console.log("eee2")
                        vroductForm__variants.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky;
                    } 
                    else if(typeof productView_price !== "undefined"  && productView_price !== null ) {
                        console.log("eee2s")
                        productView_price.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky;
                    } 
                    else if(typeof form__buy_buttons !== "undefined"  && form__buy_buttons !== null ){
                        form__buy_buttons.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky
                        console.log("eee1")
                    } 
                    else if(typeof parentDiv1 !== "undefined"  && parentDiv1 !== null ) {
                        console.log("eee2d")
                        parentDiv1.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky;
                    }
                    else if(typeof submit_form !== null  && submit_form !== null ) {
                        submit_form.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky
                        console.log("d")
                    } 
                    else if(typeof submit_form_arabic !== null  && submit_form_arabic !== null ) {
                        console.log("d2")
                        submit_form_arabic.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky
                    } 
                    else if(typeof product__title !== "undefined"  && product__title !== null ){
                        product__title.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky
                        console.log("eee1")
                    } 
                    else if(typeof product_prices !== "undefined"  && product_prices !== null ){
                        product_prices.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky
                        console.log("eee1")
                    } 
                    else if(typeof gp_price !== "undefined"  && gp_price !== null ){
                        gp_price.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky
                        console.log("eee1")
                    } 
                    else if(typeof submit !== "undefined"  && submit !== null ){
                        submit.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky
                        console.log("eee1")
                    } 
                    else if(typeof product_form__input !== "undefined"  && product_form__input !== null ) {
                        console.log("eee2zz")
                        product_form__input.insertAdjacentHTML('beforeend', quick_form);
                        document.body.innerHTML += fixed_sticky
                    }
                    else {
                        console.log("Contact Support");
                    }

                
                    // await get_id_products();
                    let product_id = document.getElementById("fast_product_id");
                    if(typeof product_id !== null  && product_id !== null  ) {
                        product_id = product_id.value;
                    } else {
                        product_id = product.id;
                    }
                    
                    await detaile_products(product_id);
                    // CREATE ORDER IN CART SHOPIFY AND SEND IN APPS
                    const el = document.getElementById("noumidia-save");
               
                    if(typeof el != null && el !== null  ) {
                        let box_shadow = true;
                        if(box_shadow) {
                            el.classList.add("btn-shadow");
                        }
                        let button_animation = true;
                        if(button_animation) {
                            el.classList.add("btn-animation");
                        }
                    }
                    try {
                        await Shopify.clear(); 
                        let default_variant = '';
                        if(meta.product.variants != null) {
                            meta.product.variants.forEach((element, index) => {
                                default_variant = element.id;
                            });
                        } else {
                            default_variant = meta.product.id;
                        }
                        let itemsAll = await Shopify.addItemFrom( default_variant , 1, 0);
                        
                        let head_product        = document.getElementById("popup-head-product-fast");
                  
                        html                    = await htmlListProduct(itemsAll);
                        if(typeof head_product !== null  && head_product !== null) {
                            head_product.innerHTML  = html;
                            head_product.style.display  = 'block';
                        }
                       

                    } catch ({ name, message }) {
                        console.log(name); // "TypeError"
                        console.log(message);
                    }
                }
            }
        }
        xhr.send(params);   
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
}

var product_id_globale = "";
// ===============================================
document.addEventListener('input', function(event) {
    try {
        let id_variant = document.getElementsByName("id")[0];
        if(typeof id_variant !== null  && id_variant !== null) {
            setTimeout(() => {
                var formData = new FormData(id_variant.form);
                for (var pair of formData.entries()) {
                    if(pair[0] == 'id') {
                        product_id_globale = pair[1];
                        product = meta.product;
                        if(product.variants != null) {
                            product.variants.forEach((element, index) => {
                                if(element.id == product_id_globale ) {
                                    display_products_cart(element);
                                }
                            });
                        }                     
                    }
                }
            }, 1000);
        } else {
            product = meta.product;
            if(product.variants != null) {
                product.variants.forEach((element, index) => {
                    product_id_globale = element.id;
                    display_products_cart(element);
                });
            } else {
                product_id_globale = product.id;
                display_products_cart(product);
            }
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); // "oops"
    }
}, false);
// START NEW CODE

async function htmlListProduct(items) {
    try {
        return new Promise(resolve => {
            let html = '';
            let price = 0;
            // items.forEach(async element => {
            let element =   items;
                let variants = '';
                element['options_with_values'].forEach(async (variant, index) => {
                    if(variant.value != "Default Title" ) {
                        if( index != 0 ) {
                            variants += ' / ';
                        }
                        variants +=  variant.name +' : '+ variant.value;
                    }
                });
                price += (element['line_price'])/100;
                let variantHtml = '';
                if( variants != '' ) {
                    variantHtml = '<span>'+ variants +'</span>';
                }
                html += `
                    <div class="popup-head-product-fast-list item-product-${element['id']}">
                        <div class="img-product-fast">
                            <div class="img-container-fast">
                                <img src="${element['image']}">
                                <span class="qty-fast-img">
                                    ${element['quantity']}
                                </span> 
                            </div> 
                        </div>
                        <div class="title-product-fast">
                            <div class="title-container-fast">
                                <h4 class="title-h4-fast"> 
                                    ${element['title']}
                                </h4> 
                                ${ variantHtml }
                                <span class="price-fast"> 
                                    <span> ${element['price']/100} ${Shopify.currency.active} </span> 
                                </span> 
                            </div> 
                        </div>
                    </div>
                `;          
            // });
            html += `
                <div style="display: none !important;" class="popup-head-product-fast-list">
                    <div class="price-title">
                        <span class="price-title"> Total </span>
                    </div>
                    <div class="price-price">
                        <span class="price-price"> ${price} ${Shopify.currency.active} </span>
                    </div>
                </div>
            `;  
            resolve(html);
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); // "oops"
    }
}



// END NEW CODE





function get_price_shipping_checked() {
    try {
        var priceShipping = 0;
        var radios = document.getElementsByName("shipping-product");
        if(typeof radios !== undefined  && radios !== null ) {
            for (var j = 0; j < radios.length; j++) {
                if(radios[j].checked) {
                    priceShipping = radios[j].getAttribute('data-price');
                }
            }  
        }
        return priceShipping;
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); // "oops"
    }
}
function get_price_discount_checked() {
    try {

        var priceDiscount   = 0;
        let type_discount   = 0;
        let valeur_discount = 0;
        let qty_discount    = 1;

        var radios = document.getElementsByName("crossel-product");
        if(typeof radios !== undefined  && radios !== null ) {
            for (var j = 0; j < radios.length; j++) {
                if(radios[j].checked) {
                    type_discount   = radios[j].getAttribute('data-type');
                    valeur_discount = radios[j].getAttribute('data-valeur');
                    qty_discount    = radios[j].getAttribute('data-qty');
                }
            } 
            let fast_price      = document.getElementById("fast-price");
            if(typeof fast_price !== null  && fast_price !== null) {
                var price = fast_price.getAttribute('data-price');
            }
    
            if( type_discount == 1 ) {
                let discount_price_attr = document.getElementById("discount-fast-price");
                if(valeur_discount!=0) {
                    var price_disc  = (price*(valeur_discount/100))*qty_discount;
                } else {
                    var price_disc  = 0;
                }
            } else if(type_discount == 2) {
                var price_disc  = valeur_discount;
            }
        }
        priceDiscount = price_disc;
        if (isNaN(priceDiscount)) {
            priceDiscount = 0;
        }
        return [priceDiscount, qty_discount];
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message);
    }
}


// ===============================================
async function display_products_cart(element) {
    try {

        let qty = 1;
        let product_qty = document.getElementById("fast-product-qty");
        if(typeof product_qty != undefined && product_qty !== null  ) {
            qty = product_qty.value; 
        }

        var priceTotal          = 0;
        var priceShipping       = 0;
        var priceDiscount       = 0;
        priceShipping           = await get_price_shipping_checked();
        priceDiscount           = await get_price_discount_checked();

        let fast_price = document.getElementById("fast-price");
        if(typeof fast_price !== undefined  && fast_price !== null) {
            priceTotal = (((parseFloat(element.price/100)*qty))*priceDiscount[1]) - parseFloat(priceDiscount[0]);
            priceTotal = parseFloat(priceShipping) + priceTotal;
            fast_price.innerHTML = priceTotal.toFixed(2) +" "+Shopify.currency.active;
            fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
            fast_price.setAttribute('data-currency' , Shopify.currency.active); 
        }
        // add new
        // let price_button = document.getElementById("price-button");
        // if(typeof price_button !== undefined  && price_button !== null) {
        //     price_button.innerHTML = " - " + parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
        // }
        let product_fast_price = document.getElementById("product-fast-price");
        if(typeof product_fast_price !== undefined  && product_fast_price !== null) {
            product_fast_price.innerHTML = ((parseFloat(element.price/100)*qty)*priceDiscount[1]).toFixed(2) +" "+Shopify.currency.active;
            product_fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
            product_fast_price.setAttribute('data-currency' , Shopify.currency.active); 
        }

    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); // "oops"
    }
}
// °°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°
// °°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°°

document.addEventListener('DOMContentLoaded', function() {
    checkUsers();
}, false);

function get_id_products() {
    try {

        return new Promise(resolve => {
            product = meta.product;
            let id_variant = document.getElementsByName("id");
            let product_id = document.getElementById("fast_product_id");
            if(typeof product_id !== null  && product_id !== null  ) {
                product_id.value = product.id;
            }
            if(product.variants != null) {
                product.variants.forEach((element, index) => {
                    if(typeof id_variant !== undefined  && id_variant[0] !== null) {
                        if(element.id == id_variant[0].value ) {
                            let fast_price = document.getElementById("fast-price");
                            if(typeof fast_price !== null  && fast_price !== null) {
                                fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                                fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                                fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                                resolve(element);
                            }
                        } else {
                            product_id_globale = element.id;
                            let fast_price = document.getElementById("fast-price");
                            if(typeof fast_price !== null  && fast_price !== null) {
                                fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                                fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                                fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                                resolve(element);
                            }
                        }
                    } else {
                        product_id_globale = element.id;
                        let fast_price = document.getElementById("fast-price");
                        if(typeof fast_price !== null  && fast_price !== null) {
                            fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                            fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                            fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                            resolve(element);
                        }
                    }
                });
            } else {
                product_id_globale = product.id;
                let fast_price = document.getElementById("fast-price");
                if(typeof fast_price !== null  && fast_price !== null) {
                    fast_price.innerHTML = parseFloat(product.price/100).toFixed(2) +" "+Shopify.currency.active;
                    fast_price.setAttribute('data-price' , parseFloat(product.price/100).toFixed(2)); 
                    fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                    resolve(product);
                }
            }
        });
    } catch ({ name, message }) {
        console.log('Mugo')
        console.log(name); // "TypeError"
        console.log(message); 
    }
}
function shipping_details(id_product) {
    try {
        // shippings-details
        var html = '';
        html += '<p><strong>Shipping Method</strong></p>';
        if(Array.isArray( shippings)) {
            shippings.forEach((element, index) => {
                element['rates'].forEach((rate, i) => {
                    let status  = '';
                    let checked = '';
                    if( i == 0 ) {
                        status  = '';
                        checked = 'checked';
                    }
                    html += `
                        <p class="shipping-item">
                            <input type="radio" id="shipping-${rate.id_rate}" ${status} data-price="${rate.price}" name="shipping-product" value="${rate.id_rate}" onclick="checkRadioShipping(${rate.id_rate})" class="shipping-radio" ${checked}>
                            <label for="shipping-${rate.id_rate}">
                                <span class="shipping-title"> ${rate.title} </span>
                                <span class="shipping-price"> ${rate.price} </span>
                            </label>
                        </p>
                    `;
                });
            });
            let shippings_details = document.getElementById("shippings-details");
            if(typeof shippings_details !== null  && shippings_details !== undefined  ) {
                shippings_details.innerHTML = html;
                if( shippings.length != 0 ) {
                    shippings_details.style.display = "block";
                }
            } 
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }

};
function detaile_products(product_id) {
    try {
        var crossel = new XMLHttpRequest();
        // GET DETAIL PRODUCT    
        product = meta.product;
        product_id = product.id;
        shipping_details(product.id);
        // START GET DISCOUNTS
        var params = "name=" + Shopify.shop+"&product_id=" + product_id;
        crossel.open('POST', 'https://fast.crodweb.com/api/details', true); 
        crossel.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        crossel.onreadystatechange = function () {
            if (crossel.readyState == 4 && crossel.status == 200) {
                let discount = JSON.parse(crossel.response);
                let html = '';
                if(Array.isArray( discount['discount'])) {
                    discount['discount'].forEach((element, index) => {
                        let status = '';
                        if( index == 0 ) {
                            status = 'checked';
                        }

                        
                        let head_product        = document.getElementById("popup-head-product-fast");
                        if(typeof head_product !== null  && head_product !== null) {
                            head_product.remove();
                        }

                        let type_discount   = element.discount_type;
                        let valueDiscount   = element.value;
                        let price           = 0;
                        if( valueDiscount == 0 ) {
                            valueDiscount = product.variants[0].price/100;
                        }


                        price       = meta.product.variants[0].price/100;
                        price       = parseFloat(price).toFixed(0);
                        let oldPrice     =  ''; 
                        let valeur_discount = element.value;
                        let qty_discount    = element.qty;
                        if( type_discount == 1 ) {
                            if(valeur_discount!=0) {
                                oldPrice = (price*(qty_discount)).toFixed(0);
                                oldPrice =  '<span class="old-price">'+ oldPrice +' '+ Shopify.currency.active +'<span></span></span>'; 
                                var price_disc = parseFloat(price)*parseFloat((valeur_discount/100));
                                price = (price - price_disc)*parseFloat(qty_discount);
                            } 
                        } else if(type_discount == 2) {
                            oldPrice = (price*(qty_discount)).toFixed(0);
                            oldPrice =  '<span class="old-price">'+ oldPrice +' '+ Shopify.currency.active +'<span></span></span>'; 
                            price = (parseFloat(price*qty_discount) - parseFloat(valeur_discount));
                        }
                        
                        html += `
                            <p>
                                <input type="radio" id="discount-${element.id_discount}" ${status} data-type="${element.discount_type}" data-valeur="${element.value}" data-qty="${element.qty}" name="crossel-product" value="${element.id_discount}" onclick="checkRadio(${element.id_discount})" class="discount-radio">
                                <label for="discount-${element.id_discount}">
                                    <span class="img-discount">
                                        <span class="qty-discount">${element.qty}</span>
                                        <img src="${element.photo}" alt="${element.discount_type}"/>
                                    </span>
                                    <span class="txt-discount">
                                        ${element.description}      
                                        <span class="price">${price} ${ Shopify.currency.active }</span>                                  
                                        ${oldPrice}                                  
                                    </span>
                                </label>
                            </p>
                        `;
                    });
                }
                // <span id="price-descount-${element.id_discount}"></span>
                let discounts_details = document.getElementById("discounts-details");
                if(typeof discounts_details !== null  && discounts_details !== null  ) {
                    discounts_details.innerHTML = html;
                } 

                if( discount['upsells'] !== undefined  && discount['upsells'].length != 0 ) {
                    upsellsList = discount['upsells'];
                    get_popup_upsells();
                }

                let sale_fast = document.getElementById("sale-fast");
                if(typeof sale_fast !== null  && sale_fast !== null  ) {
                    if( discount != null ) {
                        const result2 = discount['discount']?.length || 0;
                        if( result2 > 0 ) {
                            sale_fast.value = "discount";
                            let qty_input = document.getElementsByClassName("qty-input-fast")[0];
                            if(typeof qty_input !== null  && qty_input !== undefined  ) {
                                qty_input.style.display = "none";
                            } 
                        }                            
                    }                           
                } 
            }
        }
        crossel.send(params);
        // END DISSCOUNT
        let id_variant = document.getElementsByName("id");
        if(product.variants != null) {
            product.variants.forEach((element, index) => {
                if(typeof id_variant !== null  && id_variant[0] !== undefined) {
                    if(element.id == id_variant[0].value ) {
                        let fast_price = document.getElementById("fast-price");
                        if(typeof fast_price !== null  && fast_price !== null) {
                            fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                            fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                            fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                        }
                        let product_fast_price = document.getElementById("product-fast-price");
                        if(typeof product_fast_price !== null  && product_fast_price !== null) {
                            product_fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                            product_fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                            product_fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                        }
                    } else {
                        let fast_price = document.getElementById("fast-price");
                        if(typeof fast_price !== null  && fast_price !== null) {
                            fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                            fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                            fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                        }
                        let product_fast_price = document.getElementById("product-fast-price");
                        if(typeof product_fast_price !== null  && product_fast_price !== null) {
                            product_fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                            product_fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                            product_fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                        }
                    }
                } else {
                    let fast_price = document.getElementById("fast-price");
                    if(typeof fast_price !== null  && fast_price !== null) {
                        fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                        fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                        fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                    }
                    let product_fast_price = document.getElementById("product-fast-price");
                    if(typeof product_fast_price !== null  && product_fast_price !== null) {
                        product_fast_price.innerHTML = parseFloat(element.price/100).toFixed(2) +" "+Shopify.currency.active;
                        product_fast_price.setAttribute('data-price' , parseFloat(element.price/100).toFixed(2)); 
                        product_fast_price.setAttribute('data-currency' , Shopify.currency.active); 
                    }
                }
            });
        } else {
            let fast_price = document.getElementById("fast-price");
            if(typeof fast_price !== null  && fast_price !== null) {
                fast_price.innerHTML = parseFloat(product.price/100).toFixed(2) +" "+Shopify.currency.active;
                fast_price.setAttribute('data-price' , product.price/100); 
                fast_price.setAttribute('data-currency' , Shopify.currency.active); 
            }
            let product_fast_price = document.getElementById("product-fast-price");
            if(typeof product_fast_price !== null  && product_fast_price !== null) {
                product_fast_price.innerHTML = parseFloat(product.price/100).toFixed(2) +" "+Shopify.currency.active;
                product_fast_price.setAttribute('data-price' , product.price/100); 
                product_fast_price.setAttribute('data-currency' , Shopify.currency.active); 
            }
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }

}
// VALIDATION PHONE NUMBER
function validatePhoneNumber(input_str) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input_str);
}
// =======================================================
//  POST to cart/add.js returns the JSON of the line item.
// =======================================================
Shopify.addItemFrom = function (variant_id, quantity, callback) {
    try {
        return new Promise(resolve => {
            var xhrAb = new XMLHttpRequest();
            var params = "quantity=" + quantity + "&id=" + variant_id;
            xhrAb.open('POST', '/cart/add.js', true);
            xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrAb.onreadystatechange = function () {
                if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                    valeur = JSON.parse(xhrAb.response);
                    resolve( valeur );
                }
            }
            xhrAb.send(params);
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
};

Shopify.change = function (variant_id, quantity, callback) {
    try {
        return new Promise(resolve => {
            var xhrAb = new XMLHttpRequest();
            var params = "quantity=" + quantity + "&id=" + variant_id;
            xhrAb.open('POST', '/cart/change.js', true);
            xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrAb.onreadystatechange = function () {
                if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                    valeur = JSON.parse(xhrAb.response);
                    resolve(valeur);
                }
            }
            xhrAb.send(params);
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
};

Shopify.clear = function () {
    try {
        return new Promise(resolve => {
            let xhrClear = new XMLHttpRequest();
            xhrClear.open('POST', '/cart/clear.js', true);
            xhrClear.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrClear.onreadystatechange = function () {
                valeur =xhrClear.response;
                resolve( valeur );
            }
            xhrClear.send();
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message);
    }
};

Shopify.getProductByHandle = function (handle) {
    try {
        return new Promise(resolve => {
            var xhrAb = new XMLHttpRequest();
            xhrAb.open('GET', "/products/" + handle + ".js", true);
            xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrAb.onreadystatechange = function () {
                if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                    valeur = JSON.parse(xhrAb.response);
                    resolve(valeur);
                }
            }
            xhrAb.send();
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
};

function getProductInCart(id_variant) {
    try {
        return new Promise(resolve => {
            var xhrAb = new XMLHttpRequest();
            var item;
            xhrAb.open('GET', "/cart.js", true);

            xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrAb.onreadystatechange = async function () {
                if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                    valeur = JSON.parse(xhrAb.response);
                    valeur['items'].forEach(element => {
                        if (parseInt(element['id']) == parseInt(id_variant)) {
                            item = element['id'];
                            resolve(element);
                        }
                    });
                }
            }
            xhrAb.send();
        }); 
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
};
// Required Message Validation
function requiredMessage(input) {
    try {
        var msg_error = document.getElementById("span-"+input);
        if(typeof msg_error != null && msg_error !== null  ) {
            var input = document.getElementById(input);
            if(typeof input != null && input !== null  ) {
                var req = input.getAttribute('data-req');
                if( req == "1" && input.value == "" ) {
                    input.style.border = "1px solid red";
                    msg_error.style.display = 'block';
                    return true;
                } else {
                    input.style.border = "1px solid #F0ECECE8";
                    msg_error.style.display = 'none';
                    return false;
                }
            }
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
};
// =======================================================
// ============ SET AND GET COOKIES ======================
// =======================================================
function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
// CLICK BUTTON OPEN POPUP
async function addQty() {
    try {
        var priceShipping       = 0;
        let product_qty         = document.getElementById("fast-product-qty");
        priceShipping           = await get_price_shipping_checked();
        if(typeof product_qty != null && product_qty !== null  ) {
            let max = product_qty.getAttribute('max');
            if( parseInt(product_qty.value) < parseInt(max) ) {
                product_qty.value = parseInt(product_qty.value) + 1;
                let id_variant = document.getElementsByName("id");
                if(typeof id_variant !== null  && id_variant[0] !== undefined) {
                    await Shopify.change( id_variant[0].value , product_qty.value, 0);
                } else {
                    await Shopify.change( product_id_globale , product_qty.value, 0);
                }           
                let fast_price = document.getElementById("fast-price");
                if(typeof fast_price !== null  && fast_price !== null) {
                    let price_unit = fast_price.getAttribute('data-price');
                    if(typeof price_unit !== undefined  && price_unit !== null) { 
                        let priceTotal = parseFloat(priceShipping) + parseFloat(price_unit)*product_qty.value;
                        fast_price.innerHTML = (priceTotal).toFixed(2) +" "+Shopify.currency.active;
                    }
                    let product_fast_price = document.getElementById("product-fast-price");
                    if(typeof product_fast_price !== undefined  && product_fast_price !== null) {
                        product_fast_price.innerHTML =  (parseFloat(price_unit)*product_qty.value).toFixed(2) +" "+Shopify.currency.active;
                    }
                }
            }
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
}
// CLICK BUTTON OPEN POPUP
async function minusQty() {
    try {
        var priceShipping       = 0;
        priceShipping           = await get_price_shipping_checked();
        let product_qty = document.getElementById("fast-product-qty");
        if(typeof product_qty != null && product_qty !== null  ) {
            let min = product_qty.getAttribute('min');
            if( parseInt(product_qty.value) > parseInt(min) ) {
                if( parseInt(product_qty.value) > 1 ) {
                    product_qty.value = parseInt(product_qty.value) -1;
                    let id_variant = document.getElementsByName("id");
                    if(typeof id_variant !== null  && id_variant[0] !== undefined) {
                        await Shopify.change( id_variant[0].value , product_qty.value, 0);
                    } else {
                        await Shopify.change( product_id_globale , product_qty.value, 0);
                    }    
                    let fast_price = document.getElementById("fast-price");
                    if(typeof fast_price !== null  && fast_price !== null) {
                        let price_unit = fast_price.getAttribute('data-price');
                        if(typeof price_unit !== undefined  && price_unit !== null) { 
                            let priceTotal = parseFloat(priceShipping) + parseFloat(price_unit)*product_qty.value;
                            fast_price.innerHTML = (priceTotal).toFixed(2) +" "+Shopify.currency.active;
                        }
                        let product_fast_price = document.getElementById("product-fast-price");
                        if(typeof product_fast_price !== null  && product_fast_price !== null) {
                            product_fast_price.innerHTML =  (parseFloat(price_unit)*product_qty.value).toFixed(2) +" "+Shopify.currency.active;
                        }
                    }  
                }
            }
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }

}
// CLICK BUTTON SEND ORDER
async function addTodo() {
    try {
        document.getElementById("noumidia-save").disabled = true;
        // VALIDATION
        let req_last    = await requiredMessage("last_name");
        let req_first   = await requiredMessage("first_name");
        let req_phone   = await requiredMessage("phone");
        let req_address = await requiredMessage("address");
        let req_email   = await requiredMessage("email");
        let req_city    = await requiredMessage("city");
        let req_country = await requiredMessage("country");
        let req_note    = await requiredMessage("note");
        let req_zip     = await requiredMessage("zip_code");
        let req_state   = await requiredMessage("state");
        if( req_last || req_first || req_phone || req_address || req_email || req_city || req_country || req_note || req_zip || req_state ) {
            document.getElementById("noumidia-save").disabled = false;
            return;
        }

        let order_id = getCookie("order_id");             
        let id_variant = document.getElementsByName("id");
        // await Shopify.clear(); 
        let first_name = document.getElementById("first_name");
        if(typeof first_name !== null && first_name !== null ) {
            first_name = first_name.value;
        } else {
            first_name = "";
        }
        
        let last_name = document.getElementById("last_name");
        if(typeof last_name != null && last_name !== null ) {
            last_name = last_name.value;
        } else {
            last_name = "";
        }
        
        const ph = document.getElementById("phone");
        if(typeof ph != null && ph !== null ) {
            let phone_number = ph.value;
        } else {
            ph = "";
        }

        // let phone_error = document.getElementById('span-phone-error');
        // if(typeof phone_error != null && phone_error !== null  ) {
        //     if ( !validatePhoneNumber(ph.value) ) {
        //         phone_error.style.display = 'block';
        //         document.getElementById("noumidia-save").disabled = false;
        //         return;
        //     } else {
        //         phone_error.style.display = 'none';
        //     }
        // }    
        
        let laoder = document.getElementById("lds-ring-order");
        if(typeof laoder !== null && laoder !== undefined ) {
            laoder.style.display = "inline-block";
            document.getElementById("noumidia-save").disabled = true;
        }

        let text_span = document.getElementById("text-span-order");
        if(typeof text_span !== null && text_span !== undefined ) {
            text_span.style.display = "none";
            document.getElementById("noumidia-save").disabled = true;
        }
        
        let city = document.getElementById("city");
        if(typeof city != null && city !== null  ) {
            city = city.value;
        } else {
            city = "";
        }
        
        let phone_2 = document.getElementById("phone_2");
        if(typeof phone_2 != null && phone_2 !== null  ) {
            phone_2 = phone_2.value;
        } else {
            phone_2 = "";
        }

        let address = document.getElementById("address");
        if(typeof address !== null && address !== null ) {
            address = address.value;
        } else {
            address = "";
        }
        
        let email = document.getElementById("email");
        if(typeof email !== null && email !== null ) {
            email = email.value;
        } else {
            email = "";
        }
        
        let country = document.getElementById("country");
        if(typeof country !== null && country !== null ) {
            country = country.value;
        } else {
            country = "";
        }
        
        let note = document.getElementById("note");
        if(typeof note !== null && note !== null ) {
            note = note.value;
        } else {
            note = "";
        }
        
        let state = document.getElementById("state");
        if(typeof state !== null && state !== null ) {
            state = state.value;
        } else {
            state = "";
        }
        
        let zip_code = document.getElementById("zip_code");
        if(typeof zip_code !== null && zip_code !== null ) {
            zip_code = zip_code.value;
        } else {
            zip_code = "";
        }

        let type_qty = document.getElementById("sale-fast");
        if(typeof type_qty !== null  && type_qty !== null) {
            type_qty = type_qty.value;
        } else {
            type_qty = "qty";
        }

        var discount_id = 0;
        var crossel_product = document.getElementsByName('crossel-product');
        if(typeof crossel_product !== null  && crossel_product !== null) {
            for(i = 0; i < crossel_product.length; i++) {
                if(crossel_product[i].checked) {
                    discount_id = crossel_product[i].value;
                }
            }
        }

        var rate_id = 0;
        var shipping_product = document.getElementsByName('shipping-product');
        if(typeof shipping_product !== null  && shipping_product !== null) {
            for(i = 0; i < shipping_product.length; i++) {
                if(shipping_product[i].checked) {
                    rate_id = shipping_product[i].value;
                }
            }
        }

        var qtyVal = 1;
        if( discount_id == 0 ) {
            let qty = document.getElementById("fast-product-qty");
            if(typeof qty != null && qty !== null  ) {
                qtyVal = qty.value;
            }
        }

        var items_cart;
        if(typeof id_variant !== null  && id_variant[0] !== undefined) {
            items_cart      = await getAllProductInCart();
        } else {
            items_cart      = await getAllProductInCart();
        }

        var items = [];
        var param_prod_id   = 0;
        var param_price     = 0;
        items_cart.forEach((item,index)=>{
            items.push( 
                {
                    product_id:         item['product_id'],
                    variant_id:         item['variant_id'],
                    price:              item['price']/100,
                    product_title:      item['product_title'],
                    product_sku:        item['sku'],
                    variant_title:      item['variant_title'],
                    quantity:           item['quantity']?item['quantity']:1,
                   } 
            );
            param_prod_id   = item['product_id'];
            param_price     = item['price']/100;
        });



        var msg_error       = document.getElementById("error-message-cod");
        var message_access  = document.getElementById("form-fast");

        items = JSON.stringify(items);
        items = items.replace("\'", " ");
        items = items.replace("&", " ");

        var params = 
            "last_name=" + last_name + 
            "&first_name=" + first_name + 
            "&phone=" + ph.value + 
            "&phone_2=" + phone_2 + 
            "&city=" + city + 
            "&email=" + email + 
            "&country=" + country + 
            "&items=" + items +
            "&note=" + note + 
            "&state=" + state + 
            "&zip_code=" + zip_code + 
            "&address=" + address + 
            "&order_id=" + order_id +
            "&shop=" + Shopify.shop +
            "&currency=" + Shopify.currency.active+
            "&type_qty=" + type_qty+
            "&discount_id=" + discount_id+
            "&rate_id=" + rate_id
        ;

        try {

            if(typeof ttq != "undefined" && ttq !== null ) {
                ttq.track('CompletePayment',{
                    content_type:'product',
                    description: '"' + param_prod_id + '"',
                    content_id: param_prod_id,
                    quantity: qtyVal,
                    price: param_price,
                    value: param_price,
                    currency: Shopify.currency.active});
            }

            if(typeof fbq != "undefined" && fbq !== null ) {
                fbq('track', 'Purchase', {
                    currency: Shopify.currency.active,
                    value: param_price
                },{eventID:new Date().getTime()});
            }

            if(typeof snaptr != "undefined" && snaptr !== null ) {
                snaptr('track', 'PURCHASE', {
                    'currency': Shopify.currency.active,
                    'price': param_price,
                    'item_category': '',
                    'item_ids': ''
                });
            }

            if(typeof ga != "undefined" && ga !== null ) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Products',
                    eventAction: param_prod_id,
                    eventLabel: param_price
                });
            }

        } catch ({ name, message }) {
            console.log(name); // "TypeError"
            console.log(message);  
        }

        return new Promise(resolve => { 
            var xhrOr = new XMLHttpRequest();
            xhrOr.open('POST', 'https://fast.crodweb.com/api/create', true);
            xhrOr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrOr.onreadystatechange = async function () {
                if (xhrOr.readyState == 4 && xhrOr.status == 200) {

                    await Shopify.clear();
                
                    let res = "["+xhrOr.response+"]";
                    res = JSON.parse(res);
                    if (res[0].status == 0) {
                        msg_error.innerText = "Your order is then failed, Please try again";
                        msg_error.style.display = 'block';
                    } else {

                        setCookie("order_id", res[0].id, 1);
                        if( upsellsList !== undefined && upsellsList.length !=0 ) {

                            if( upsellsList.product_achete == param_prod_id ) {
                                let body = document.getElementsByTagName('body')[0];
                                if(typeof body != null && body !== null  ) {
                                    body.classList.remove("modal-open-fast");
                                }
        
                                let popupOpen = document.getElementById('popup-form-upsells');

                                if(typeof body != null && body !== null  ) {
                                    popupOpen.classList.add("show");
                                    if( res[0].url != null && res[0].url != false ) {
                                        urlThankYou = res[0].url;
                                    }
                                } else {
                                    //location.reload();
                                }   
                            
                            }
                        } else {
                            if( res[0].url != null && res[0].url != false ) {
                                if( res[0].type != null && res[0].type == "page" ) {
                                    let paramas_order = '?price='+ param_price +'&currency='+Shopify.currency.active+'&item_category='+ param_prod_id;
                                    return resolve(window.location.replace(res[0].url));   
                                } else {
                                    return resolve(window.location.replace(res[0].url));   
                                }  
                            } else {
                                // msg_error.innerText = 'Your order is then successfully';
                                // msg_error.classList.add("sucess-order");

                                if(typeof message_access !== null  && message_access !== null) {
                                    message_access.innerText = "";
                                    message_access.innerHTML = "<p class='send-order'>Your order is then successfully</p>";
                                }

                                let form_fast = document.getElementById("form-fast-input");
                                if(typeof form_fast !== null  && form_fast !== null) {
                                    form_fast.style.display = 'none';
                                }

                                let noumidia_save = document.getElementById("noumidia-save");
                                if(typeof noumidia_save !== null  && noumidia_save !== null) {
                                    noumidia_save.style.display = 'none';
                                }
                            }
                        }
                    }
                } else {
                    console.log(xhrOr)
                }
            }
            xhrOr.send(params);
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message);
    }
}
// GET ALL PRODUCTS IN CART PAGE
function getAllProductInCart() {
    try {
        return new Promise(resolve => {
            var xhrAb = new XMLHttpRequest();
            var item;
            xhrAb.open('GET', "/cart.js", true);
            xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrAb.onreadystatechange = async function () {
                if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                    valeur = JSON.parse(xhrAb.response);
                    // valeur['items'].forEach(element => {
                        resolve(valeur['items']);
                    // });
                }
            }
            xhrAb.send();
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); // "oops"
    }
};
// Check Radio button crossel
async function checkRadio(id) {
    try {
        let discount = document.getElementById("discount-"+id);

        var radios = document.getElementsByName("crossel-product");
        for (var j = 0; j < radios.length; j++) {
            radios[j].removeAttribute("checked");
        }

        var priceShipping       = 0;
        priceShipping           = await get_price_shipping_checked();

        var priceDiscount       = 0;
        priceDiscount           = await get_price_discount_checked();

        if(typeof discount !== null  && discount !== null) {

            discount.checked = true;
            discount.setAttribute("checked", "checked");

            let type_discount = discount.getAttribute('data-type');
            let valeur_discount = discount.getAttribute('data-valeur');
            let qty_discount = discount.getAttribute('data-qty');
            let fast_price = document.getElementById("fast-price");
            if(typeof fast_price !== null  && fast_price !== null) {
                let price = fast_price.getAttribute('data-price');
                let product_price = fast_price.getAttribute('data-price');
                if( type_discount == 1 ) {
                    let discount_price_attr = document.getElementById("discount-fast-price");
                    let discount_price_div = document.getElementById("discount_price");
                    if(valeur_discount!=0) {
                        var price_disc = price*(valeur_discount/100);
                        price = (price - price_disc)*qty_discount;
                        if(typeof discount_price_attr !== null  && discount_price_attr !== null) {
                            discount_price_attr.innerHTML = "-" + parseFloat(price_disc*qty_discount).toFixed(2) +" "+Shopify.currency.active;
                            discount_price_attr.setAttribute('data-price' , price_disc); 
                            discount_price_attr.setAttribute('data-currency' , Shopify.currency.active); 
                            if(typeof discount_price_div !== null  && discount_price_div !== null) {
                                discount_price_div.classList.remove("fast-none");
                            }
                        }
                    } else {
                        if(typeof discount_price_div !== null  && discount_price_div !== null) {
                            discount_price_div.classList.add("fast-none");
                        }
                    }
                } else if(type_discount == 2) {
                    var price_disc = valeur_discount;
                    price = ((price*qty_discount) - price_disc);
                    let discount_price_attr = document.getElementById("discount-fast-price");
                    let discount_price_div = document.getElementById("discount_price");
                    if(typeof discount_price_attr !== null  && discount_price_attr !== null) {
                        discount_price_attr.innerHTML = "-" + ((parseFloat(price_disc).toFixed(2))) +" "+Shopify.currency.active;
                        discount_price_attr.setAttribute('data-price' , price_disc); 
                        discount_price_attr.setAttribute('data-currency' , Shopify.currency.active); 
                        if(typeof discount_price_div !== null  && discount_price_div !== null) {
                            discount_price_div.classList.remove("fast-none");
                            if( valeur_discount == 0 ) {
                                discount_price_div.classList.add("fast-none");
                            }
                        }
                    }
                }
                fast_price.innerHTML = (parseFloat(price)+parseFloat(priceShipping)).toFixed(2) +" "+Shopify.currency.active;
                
                let product_fast_price = document.getElementById("product-fast-price");
                if(typeof product_fast_price !== null  && product_fast_price !== null) {
                    product_fast_price.innerHTML = (parseFloat(product_price).toFixed(2)*qty_discount).toFixed(2) +" "+Shopify.currency.active;
                }
            }
        } 
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
}
// Check Radio button crossel
async function checkRadioShipping(id) {
    try {
        let shipping = document.getElementById("shipping-"+id);

        var radios = document.getElementsByName("shipping-product");
        for (var j = 0; j < radios.length; j++) {
            radios[j].removeAttribute("checked");
        }

        var priceDiscount       = 0;
        priceDiscount           = await get_price_discount_checked();

        if(typeof shipping !== null  && shipping !== undefined) {
            shipping.checked = true;
            shipping.setAttribute("checked", "checked");

            let price_shipping  = shipping.getAttribute('data-price');
            let fast_price      = document.getElementById("fast-price");
            if(typeof fast_price !== null  && fast_price !== null) {
                let product_qty = document.getElementById("fast-product-qty");
                let qty = 1;
                if(typeof product_qty != null && product_qty !== undefined  ) {
                    qty = product_qty.value; 
                }
                let price = fast_price.getAttribute('data-price');
                price = ((parseFloat(price)*qty)*priceDiscount[1]) - parseFloat(priceDiscount[0]) + parseFloat(price_shipping);
                fast_price.innerHTML = parseFloat(price).toFixed(2) +" "+Shopify.currency.active;
            }

            let product_fast_price = document.getElementById("product-fast-price");
            if(typeof product_fast_price !== null  && product_fast_price !== null) {
                let product_qty = document.getElementById("fast-product-qty");
                let qty = 1;
                if(typeof product_qty != null && product_qty !== undefined  ) {
                    qty = product_qty.value; 
                }
                let price = product_fast_price.getAttribute('data-price');
                price = (parseFloat(price)*qty)*priceDiscount[1];
                product_fast_price.innerHTML = price.toFixed(2) +" "+Shopify.currency.active;
            }

        } 
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
}
// FOCUSOUT
async function customerAbandoned() {
    try {
        // CREATE ABANDOND ORDER IN CART SHOPIFY AND SEND IN APPS
        var phone = document.getElementById("phone");
        if(typeof phone != null && phone !== null  ) {
            let id_variant = document.getElementsByName("id");
            var items_cart;
            if(typeof id_variant !== null  && id_variant[0] !== undefined) {
                items_cart = await getProductInCart(id_variant[0].value);
            } else {
                items_cart = await getProductInCart(product_id_globale);
            }
            
            var xhrAb = new XMLHttpRequest();

            let first_name = document.getElementById("first_name");
            if(typeof first_name !== null  && first_name !== null  ) {
                first_name = first_name.value;
            }

            let last_name = document.getElementById("last_name");
            if(typeof last_name != null && last_name !== null  ) {
                last_name = last_name.value;
            }

            var items = [
                {
                    product_id: items_cart['product_id'],
                    variant_id: items_cart['variant_id'],
                    price: items_cart['price'],
                    variant_title: items_cart['variant_title'],
                    quantity: items_cart['quantity']?items_cart['quantity']:1,
                }
            ];
        
            var params =
                "product_id=" + items_cart['product_id'] +
                "&variant_id=" + items_cart['variant_id'] +
                "&price=" + items_cart['price'] +
                "&variant_title=" + items_cart['variant_title'] +
                "&items=" + JSON.stringify(items) +
                "&first_name=" + first_name +
                "&last_name=" + last_name +
                "&phone=" + phone.value +
                "&shop=" + Shopify.shop +
                "&currency=" + Shopify.currency.active
            ;
        
            xhrAb.open('POST', 'https://fast.crodweb.com/api/customer', true);
            xhrAb.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhrAb.onreadystatechange = async function () {
                if (xhrAb.readyState == 4 && xhrAb.status == 200) {
                    let res = "["+xhrAb.response+"]";
                    res = JSON.parse(res);
                    if (res[0].status == 0) {
                        // Not response
                    } else {
                        setCookie("order_id", null, 1);
                        if( res[0].url != null ) {
                            return resolve(window.location.replace(res[0].url));   
                        }
                    }
                    document.getElementById("noumidia-save").disabled = false;
                }
            }
            xhrAb.send(params);
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message);
    }
}
function movaToFast() {
    try {
        // var form_fast_move_ = document.getElementById("product-form");
        var form_fast_move_ = document.getElementsByClassName("product-form")[0];
        if(typeof form_fast_move_ != null && form_fast_move_ !== null  ) {
            form_fast_move_.scrollIntoView({
                block: "start",
                behavior: "smooth"
            });
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
}
// **************VERSION*****************
// console.log('SCRIPT NEWS 1.1.1')


// *******--*******//

var upsellsRequest = async () => {
    try {
        var id_variant_upsell = document.getElementById('id_variant_upsell');
        if(typeof id_variant_upsell != undefined ) {
            id_variant_upsell = id_variant_upsell.value;
        }
        var product_achete = upsellsList.product_achete;
        var product_offer = document.getElementById('product_offer');
        if(typeof product_offer != undefined ) {
            product_offer = product_offer.value;
        }

        let order_id = getCookie("order_id");  

        var xmlhttp = await new XMLHttpRequest();
        var params = 
            "shop=" + Shopify.shop +
            "&product_offer=" + product_offer +
            "&product_achete=" + product_achete+
            "&id_variant_upsell=" + id_variant_upsell+
            "&order_id=" + order_id
        ;

        document.getElementById("add-upsells").disabled = false;
        
        let laoder = document.getElementById("loeder-ring");
        if(typeof laoder !== null && laoder !== null ) {
            laoder.style.display = "inline-block";
        }

        let text_upsells_btn = document.getElementById("text-upsells-btn");
        if(typeof text_upsells_btn !== null && text_upsells_btn !== null ) {
            text_upsells_btn.style.display = "none";
        }

        let lds = document.getElementById("lds-ring");
        if(typeof lds !== null && lds !== null ) {
            lds.style.display = "none";
        }

        return new Promise(resolve => {
            xmlhttp.open('POST', 'https://fast.crodweb.com/api/create/upsells', true);
            xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xmlhttp.onload = () => resolve({
                status: xmlhttp.status,
                response: xmlhttp.responseText
            });
            xmlhttp.onerror = () => resolve({
                status: xmlhttp.status,
                response: xmlhttp.responseText
            });
            xmlhttp.send(params);
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
} 

async function set_create_upsells() {
    try {
        let request = await upsellsRequest();
        if( request.status == 200 || request.status == 201 ) {
            var response = JSON.parse(request.response);
            if( response['type'] != null && response['type'] == "page" ) {
                window.location.replace(response['url']);   
            } else {
                if(urlThankYou != null) {
                    window.location.replace(urlThankYou);   
                } else {
                    location.reload();
                }
            }
        } else {        
            let row_form_upsells = document.getElementById("row-form-upsells");
            if(typeof row_form_upsells !== null  && row_form_upsells !== null) {
                row_form_upsells.innerHTML = "Your order is then successfully";
            }

        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
}

var productUpsell = null;
var productsRequest = async () => {
    try {
        var xmlhttp = await new XMLHttpRequest();
        return new Promise(resolve => {
            xmlhttp.open("GET", window.Shopify.routes.root + 'products/'+ upsellsList.handle +'.json', false);
            xmlhttp.onload = () => resolve({
                status: xmlhttp.status,
                response: xmlhttp.responseText
            });
            xmlhttp.onerror = () => resolve({
                status: xmlhttp.status,
                response: xmlhttp.responseText
            });
            xmlhttp.send();
        });
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
}

async function get_popup_upsells() {
    try {
        var htmlElem = ''; 
        let request = await productsRequest();
        if(request.status) {
            var formatJson = JSON.parse(request.response);
            product = formatJson['product'];
        
            if( product.id == upsellsList.product_offere ) {
                productUpsell = product;
                var listImg         = '';
                var listOptions     = '';
                if( product.images.length > 1 ) {
                    product.images.forEach((image, index) => {
                        if( index < 4 ) {
                            listImg += `
                                <div class="img-form-list">
                                    <img src="${ image.src }" alt="" srcset="">
                                </div>
                            `;
                        }
                    });
                }
                if( product.options.length > 1 ) {
                    product.options.forEach((option, index) => {
                        listOptions += `<span class="title-options">${ option.name }</span>`;
                        listOptions += `<div id="option-${ index }" class="form-option">`;
                        option.values.forEach((o, i) => {
                            let optionCurrent = '';
                            if(i == 0) {
                                optionCurrent = 'option-active option-active-'+index;
                            }
                            listOptions += `
                                <a id="${ o }" data-value="${ o }" class="option-${index} ${optionCurrent}" onclick="changeVariant(${index},${o})">${ o }</a>
                            `;
                        });
                        listOptions += `</div>`;
                    });
                }

                if( product.options.length == 1 && product.options[0].name == "Title" ) {
                    let available = product.variants[0].available;
                    let price = product.variants[0].price;
                    let compare_at_price = product.variants[0].compare_at_price;
                    var upsellsValue     = upsellsList.value;
                    
                    if( upsellsList.discount == '1' ) {
                        price = (parseFloat(price) - parseFloat(price)*(parseFloat(upsellsValue)/100)).toFixed(2);
                    } else if( upsellsList.discount == '2' ) {
                        price = (parseFloat(price) - parseFloat(upsellsValue)).toFixed(2);
                    }

                    htmlElem += `
                        <div class="img-form-upsells">
                            <div class="img-main-form-upsells">
                                <img src="${ product.images[0].src }" alt="" srcset="">
                            </div>
                            <div class="img-list-form-upsells">
                                ${listImg}
                            </div>
                        </div>
                        <div class="detail-form-upsells">
                            <div class="detail-form-content">
                                <h2>
                                    ${ product.title }
                                </h2>
                                <div class="detail-form-price">
                                    <span class="form-price-regular">${ price + ' ' + Shopify.currency.active }</span>
                                    <span class="form-price-compare">${ compare_at_price + ' ' + Shopify.currency.active }</span>
                                </div>
                                <div class="detail-form-button">
                                    <a id="add-upsells" class="add-upsells" onclick="set_create_upsells()">
                                        <div id="loeder-ring" class="loeder-ring"><div></div><div></div><div></div><div></div></div>	
                                        <span id="text-upsells-btn">
                                        Add To Order
                                        </span>
                                    </a>
                                    <a id="cancel-upsells" class="cancel-upsells" onclick="cancel_upsells()">
                                    Cancel
                                    </a>
                                </div>
                            </div>
                        </div>
                    `;
                } else if( product.options.length > 1 ) {
                    let available = product.variants[0].available;
                    let price = product.variants[0].price;
                    let compare_at_price = product.variants[0].compare_at_price;
                    let upsellsValue = upsellsList.value;

                    if( upsellsList.discount == '1' ) {
                        price = (parseFloat(price) - parseFloat(price)*(parseFloat(upsellsValue)/100)).toFixed(2);
                    } else if( upsellsList.discount == '2' ) {
                        price = (parseFloat(price) - parseFloat(upsellsValue)).toFixed(2);
                    }

                    htmlElem += `
                        <div class="img-form-upsells">
                            <div class="img-main-form-upsells">
                                <img src="${ product.images[0].src }" alt="" srcset="">
                            </div>
                            <div class="img-list-form-upsells">
                                ${listImg}
                            </div>
                        </div>
                        <div class="detail-form-upsells">
                            <div class="detail-form-content">
                                <h2>
                                    ${ product.title }
                                </h2>
                                <div class="detail-form-price">
                                    <span id="form-price-regular" class="form-price-regular">${ price + ' ' + Shopify.currency.active }</span>
                                    <span id="form-price-compare" class="form-price-compare">${ compare_at_price + ' ' + Shopify.currency.active }</span>
                                </div>
                                <div class="detail-form-variants">
                                    ${ listOptions }
                                </div>
                                <div class="detail-form-button">
                                    <a id="add-upsells" class="add-upsells" onclick="set_create_upsells()">
                                        <div id="loeder-ring" class="loeder-ring"><div></div><div></div><div></div><div></div></div>	
                                        <span id="text-upsells-btn">
                                        Add To Order
                                        </span>
                                    </a>
                                    <a id="cancel-upsells" class="cancel-upsells" onclick="cancel_upsells()">
                                    Cancel
                                    </a>
                                </div>
                            </div>
                        </div>
                    `;
                }

                var elementPopup = `
                    <div id="popup-form-upsells" class="popup-form-upsells">
                        <div class="popup-form-content">
                            <div id="row-form-upsells" class="row-form-upsells">
                                <div class="title-offer-upsells">
                                    ${ upsellsList.description }
                                </div>
                                ${ htmlElem }
                            </div>
                        </div>
                        <input type="hidden" name="id_variant_upsell" id="id_variant_upsell" value="">
                        <input type="hidden" name="product_offer" id="product_offer" value="">
                    </div>   

                    <style>
                            
                        .loeder-ring {
                            display: inline-block;
                            position: relative;
                            width: 25px;
                            height: 25px;
                            display: none;
                        }

                        .loeder-ring div {
                            box-sizing: border-box;
                            display: block;
                            position: absolute;
                            width: 21px;
                            height: 21px;
                            margin: 8px;
                            border: 3px solid #fff;
                            border-radius: 50%;
                            animation: loeder-ring 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
                            border-color: #fff transparent transparent transparent;
                            display: flex;
                        }

                        .loeder-ring div:nth-child(1) {
                            animation-delay: -0.45s;
                        }

                        .loeder-ring div:nth-child(2) {
                            animation-delay: -0.3s;
                        }

                        .loeder-ring div:nth-child(3) {
                            animation-delay: -0.15s;
                        }

                        @keyframes loeder-ring {
                            0% {
                            transform: rotate(0deg);
                            }
                            100% {
                            transform: rotate(360deg);
                            }
                        }
                        .popup-form-upsells {
                            position: fixed;
                            top: 0;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            background: rgba(0, 0, 0, 0.7);
                            transition: opacity 500ms;
                            visibility: hidden;
                            opacity: 0;
                            z-index: 999999;
                            overflow: auto;
                        }
                        .popup-form-upsells.show {
                            visibility: visible;
                            opacity: 1;
                        }
                        .popup-form-upsells .popup-form-content .title-offer-upsells {
                            text-align: center;
                            width: 100%;
                            padding: 10px 0px;
                            color: green;
                            font-weight: 900;
                            font-size: 20px;
                        }
                        .popup-form-upsells .popup-form-content {
                            margin: 70px auto;
                            padding: 20px;
                            background: #fff;
                            border-radius: 5px;
                            width: 30%;
                            position: relative;
                            transition: all 5s ease-in-out;
                            max-width: 400px;
                        }
                        .popup-form-upsells .show {
                            visibility: visible;
                            -webkit-animation: fadeIn 1s;
                            animation: fadeIn 1s
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells {
                            display: flex;
                            flex-wrap: wrap;
                            width: 100%
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .img-form-upsells { 
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .img-form-upsells .img-main-form-upsells { 
                            width: 100%;
                            flex: 0 0 100%;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .img-form-upsells .img-main-form-upsells img { 
                            display: flex;
                            width: 100%;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .img-form-upsells .img-list-form-upsells { 
                            width: 100%;
                            display: flex;
                            margin: 10px 0px;
                            flex: 0 0 100%;
                            justify-content: center;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .img-form-upsells .img-list-form-upsells .img-form-list{ 
                            flex: 0 0 25%;
                            padding: 0px 5px;
                            overflow: hidden;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .img-form-upsells .img-list-form-upsells .img-form-list img { 
                            width: 100%;
                            height: auto;
                            border-radius: 6px;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .img-form-upsells .img-list-form-upsells .img-form-list img:hover { 
                            cursor: pointer;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells { 
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                            width: 100%;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells h2 { 
                            font-size: 19px;
                            color: #333;
                            font-weight: 700;
                            line-height: 20px !important;
                            padding: 15px 0px;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-price { 
                        display: flex;
                        flex-wrap: wrap;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-price .form-price-regular { 
                            font-weight: 700;
                            color: #333;
                            padding-right: 15px;
                            font-size: 17px;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-price .form-price-compare { 
                            font-weight: 700;
                            color: red;
                            font-size: 16px;
                            -webkit-text-decoration-line: line-through;
                            text-decoration-line: line-through;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-button { 
                            display: flex;
                            flex-wrap: wrap;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-button .add-upsells:hover {
                            opacity: 0.8;   
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-button .add-upsells { 
                            border: 1px solid green;
                            border-radius: 5px;
                            display: inline-block;
                            font-size: 16px;
                            font-weight: 700;
                            line-height: 20px;
                            cursor: pointer;
                            text-transform: none;
                            transition: all .32s;
                            background-color:  #ffffff;
                            color: #000000;
                            width: 100%;
                            padding: 15px 0px;
                            display: block;
                            margin: 15px 0px 0px;
                            text-align: center;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-button .cancel-upsells:hover { 
                            opacity: 0.8;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-button .cancel-upsells { 
                            border: 1px solid red;
                            border-radius: 5px;
                            display: inline-block;
                            font-size: 16px;
                            font-weight: 700;
                            line-height: 20px;
                            cursor: pointer;
                            text-transform: none;
                            transition: all .32s;
                            background-color: #f22121;
                            color: #ffffff;
                            width: 100%;
                            padding: 15px 0px;
                            display: block;
                            margin: 15px 0px 0px;
                            text-align: center;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-variants { 
                            display: flex;
                            flex-wrap: wrap;
                            width: 100%;
                            margin: 20px 0px;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-variants .form-option { 
                            flex: 0 0 100%;
                            display: flex;
                            margin: 5px 0px;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-variants .form-option a { 
                            padding: 5px 10px;
                            border: 1px solid #babfba;
                            text-decoration: none;
                            text-align: center;
                            min-width: 60px;
                            margin: 0px 5px;
                            border-radius: 5px;
                            color: #4a4242;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-variants .form-option a:hover {
                            color: #222222;
                        }
                        .popup-form-upsells .popup-form-content .row-form-upsells .detail-form-upsells .detail-form-variants .form-option a.option-active {
                            border: 2px solid green;
                        }
                        @-webkit-keyframes fadeIn {
                            from {opacity: 0;}
                            to {opacity: 1;}
                        }

                        @keyframes fadeIn {
                            from {opacity: 0;}
                            to {opacity:1 ;}
                        }
                        @media screen and (max-width: 998px) {
                            .popup-form-upsells .popup-form-content {
                                width: 80%;
                            }
                        }
                        @media screen and (max-width: 600px) {
                            .popup-form-upsells .popup-form-content {
                                width: 98%;
                            }
                        }
                    </style>
                `;

                document.body.innerHTML += elementPopup;

                var id_variant_upsell = document.getElementById('id_variant_upsell');
                if(typeof id_variant_upsell != null && id_variant_upsell !== null  ) {
                    id_variant_upsell.value = productUpsell.variants[0].id;
                }

                var product_offer = document.getElementById('product_offer');
                if(typeof product_offer != null && product_offer !== null  ) {
                    product_offer.value = productUpsell.id;
                }

            }

        }

    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message);
    }
}

async function changeVariant(i, o) {
    try {
        var optionChose = o.innerHTML;
        if( i == 0 ) {
            var option_0_active = document.getElementsByClassName("option-0");
            if (option_0_active.length > 0) {
                [].forEach.call(option_0_active, function(el) {
                    el.classList.remove("option-active-0");
                    el.classList.remove("option-active");
                });
            }
        } else if( i == 1 ) {
            var option_0_active = document.getElementsByClassName("option-1");
            if (option_0_active.length > 0) {
                [].forEach.call(option_0_active, function(el) {
                    el.classList.remove("option-active-1");
                    el.classList.remove("option-active");
                });
            }
        } else if( i == 2 ) {
            var option_0_active = document.getElementsByClassName("option-1");
            if (option_0_active.length > 0) {
                [].forEach.call(option_0_active, function(el) {
                    el.classList.remove("option-active-2");
                    el.classList.remove("option-active");
                });
            }
        }
        var variant_active = null;
        productUpsell.variants.forEach((variant, index) => {
            if( i == 0 ) {
                if( variant.option1 == optionChose ) {
                    if( variant.option2 ) {
                        if( variant.option3 ) {
                            var optionActive3 = document.getElementsByClassName("option-active-2");
                            if (optionActive3.length > 0) {
                                var optionChose3 = optionActive3[0].getAttribute('data-value');
                                if( optionChose3 == variant.option3 ) {
                                    variant_active = variant;
                                }
                            }
                        } else {
                            var optionActive2 = document.getElementsByClassName("option-active-1");
                            if (optionActive2.length > 0) {
                                var optionChose2 = optionActive2[0].getAttribute('data-value');
                                if( optionChose2 == variant.option2 ) {
                                    variant_active = variant;
                                }
                            }
                        }
                        var option_0_active_new = document.getElementById(optionChose);
                        if(typeof option_0_active_new != null && option_0_active_new !== null  ) {
                            option_0_active_new.classList.add("option-active-0");
                            option_0_active_new.classList.add("option-active");
                        }
                    } else {
                        variant_active = variant;
                        var option_0_active_new = document.getElementById(optionChose);
                        if(typeof option_0_active_new != null && option_0_active_new !== null  ) {
                            option_0_active_new.classList.add("option-active-0");
                            option_0_active_new.classList.add("option-active");
                        }
                    }
                }
            } else if( i == 1 ) {
                if( variant.option2 == optionChose ) {
                    if( variant.option3 ) {
                        var optionActive1 = document.getElementsByClassName("option-active-0");
                        if (optionActive1.length > 0) {
                            var optionChose1 = optionActive1[0].getAttribute('data-value');
                        }
                        var optionActive3 = document.getElementsByClassName("option-active-2");
                        if (optionActive3.length > 0) {
                            var optionChose3 = optionActive3[0].getAttribute('data-value');
                            if( optionChose3 == variant.option3 && optionChose1 == variant.option1 ) {
                                variant_active = variant;
                                var optionActive3 = document.getElementsByClassName("option-active-2");
                                var option_1_active_new = document.getElementById(optionChose);
                                if(typeof option_1_active_new != null && option_1_active_new !== null  ) {
                                    option_1_active_new.classList.add("option-active-1");
                                    option_1_active_new.classList.add("option-active");
                                }
                            }
                        }
                    } else {
                        var optionActive1 = document.getElementsByClassName("option-active-0");
                        if (optionActive1.length > 0) {
                            var optionChose1 = optionActive1[0].getAttribute('data-value');
                            if( optionChose1 == variant.option1 ) {
                                variant_active = variant;
                                var option_1_active_new = document.getElementById(optionChose);
                                if(typeof option_1_active_new != null && option_1_active_new !== null  ) {
                                    option_1_active_new.classList.add("option-active-1");
                                    option_1_active_new.classList.add("option-active");
                                }
                            }
                        }
                    }
                }
            }
        });
        var id_variant_upsell = document.getElementById('id_variant_upsell');
        if(typeof id_variant_upsell != null && id_variant_upsell !== null  ) {
            id_variant_upsell.value = variant_active.id;
        }
        var form_price_regular = document.getElementById('form-price-regular');
        if(typeof form_price_regular != null && form_price_regular !== null  ) {
            var price           = variant_active.price;
            var upsellsValue    = upsellsList.value;

            if( upsellsList.discount == '1' ) {
                price = (parseFloat(variant_active.price) - parseFloat(variant_active.price)*(parseFloat(upsellsValue)/100)).toFixed(2);
            } else if( upsellsList.discount == '2' ) {
                price = (parseFloat(variant_active.price) - parseFloat(upsellsValue)).toFixed(2);
            }
            form_price_regular.value = price;
        }
        var compare_at_price        = document.getElementById('form-price-compare');
        var compare_at_price_val    = variant_active.price;

        if(typeof compare_at_price != null && compare_at_price !== null  ) {
            compare_at_price.value = compare_at_price_val;
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message); 
    }
}

function cancel_upsells() {
    try {
        if( urlThankYou != null ) {
            window.location.replace(urlThankYou);   
        } else {
            location.reload();
        }
    } catch ({ name, message }) {
        console.log(name); // "TypeError"
        console.log(message);
    }
}

console.log('Embeded 2,2')